import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AboutPageSectionsDynamicZoneInput: { input: any; output: any; }
  BlogPostSectionsDynamicZoneInput: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  HomePageSectionsDynamicZoneInput: { input: any; output: any; }
  I18NLocaleCode: { input: any; output: any; }
  InformationSectionsDynamicZoneInput: { input: any; output: any; }
  InspirationSectionsDynamicZoneInput: { input: any; output: any; }
  JSON: { input: any; output: any; }
  ListingSectionsDynamicZoneInput: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AboutPage = {
  __typename?: 'AboutPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  header?: Maybe<ComponentPartsHeader>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<AboutPageRelationResponseCollection>;
  sections?: Maybe<Array<Maybe<AboutPageSectionsDynamicZone>>>;
  seo?: Maybe<ComponentPartsSeo>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AboutPageEntity = {
  __typename?: 'AboutPageEntity';
  attributes?: Maybe<AboutPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AboutPageEntityResponse = {
  __typename?: 'AboutPageEntityResponse';
  data?: Maybe<AboutPageEntity>;
};

export type AboutPageInput = {
  header?: InputMaybe<ComponentPartsHeaderInput>;
  sections?: InputMaybe<Array<Scalars['AboutPageSectionsDynamicZoneInput']['input']>>;
  seo?: InputMaybe<ComponentPartsSeoInput>;
};

export type AboutPageRelationResponseCollection = {
  __typename?: 'AboutPageRelationResponseCollection';
  data: Array<AboutPageEntity>;
};

export type AboutPageSectionsDynamicZone = ComponentSectionsBanner | ComponentSectionsContentSection | ComponentSpecialCustomComponent | ComponentSpecialStoryCarousel | Error;

export type BlogPost = {
  __typename?: 'BlogPost';
  category?: Maybe<Enum_Blogpost_Category>;
  cover_image?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<BlogPostRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sections?: Maybe<Array<Maybe<BlogPostSectionsDynamicZone>>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url_key?: Maybe<Scalars['String']['output']>;
};


export type BlogPostLocalizationsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogPostEntity = {
  __typename?: 'BlogPostEntity';
  attributes?: Maybe<BlogPost>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BlogPostEntityResponse = {
  __typename?: 'BlogPostEntityResponse';
  data?: Maybe<BlogPostEntity>;
};

export type BlogPostEntityResponseCollection = {
  __typename?: 'BlogPostEntityResponseCollection';
  data: Array<BlogPostEntity>;
  meta: ResponseCollectionMeta;
};

export type BlogPostFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<BlogPostFiltersInput>;
  not?: InputMaybe<BlogPostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url_key?: InputMaybe<StringFilterInput>;
};

export type BlogPostInput = {
  category?: InputMaybe<Enum_Blogpost_Category>;
  cover_image?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sections?: InputMaybe<Array<Scalars['BlogPostSectionsDynamicZoneInput']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  url_key?: InputMaybe<Scalars['String']['input']>;
};

export type BlogPostRelationResponseCollection = {
  __typename?: 'BlogPostRelationResponseCollection';
  data: Array<BlogPostEntity>;
};

export type BlogPostSectionsDynamicZone = ComponentSectionsProductsList | ComponentSectionsRichtext | Error;

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cart = {
  __typename?: 'Cart';
  cartbanner?: Maybe<ComponentCartCartBanner>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<CartRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CartEntity = {
  __typename?: 'CartEntity';
  attributes?: Maybe<Cart>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CartEntityResponse = {
  __typename?: 'CartEntityResponse';
  data?: Maybe<CartEntity>;
};

export type CartInput = {
  cartbanner?: InputMaybe<ComponentCartCartBannerInput>;
};

export type CartRelationResponseCollection = {
  __typename?: 'CartRelationResponseCollection';
  data: Array<CartEntity>;
};

export type ComponentCartCartBanner = {
  __typename?: 'ComponentCartCartBanner';
  Items?: Maybe<Array<Maybe<ComponentCartItem>>>;
  id: Scalars['ID']['output'];
};


export type ComponentCartCartBannerItemsArgs = {
  filters?: InputMaybe<ComponentCartItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCartCartBannerInput = {
  Items?: InputMaybe<Array<InputMaybe<ComponentCartItemInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCartItem = {
  __typename?: 'ComponentCartItem';
  date_from: Scalars['DateTime']['output'];
  date_to: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentCartItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCartItemFiltersInput>>>;
  date_from?: InputMaybe<DateTimeFilterInput>;
  date_to?: InputMaybe<DateTimeFilterInput>;
  not?: InputMaybe<ComponentCartItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCartItemFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentCartItemInput = {
  date_from?: InputMaybe<Scalars['DateTime']['input']>;
  date_to?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentEngravingEngraving = {
  __typename?: 'ComponentEngravingEngraving';
  Description?: Maybe<Scalars['String']['output']>;
  Image: UploadFileEntityResponse;
  ImageToSend: UploadFileEntityResponse;
  StartingDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentEngravingEngravingFiltersInput = {
  Description?: InputMaybe<StringFilterInput>;
  StartingDate?: InputMaybe<DateTimeFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentEngravingEngravingFiltersInput>>>;
  not?: InputMaybe<ComponentEngravingEngravingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentEngravingEngravingFiltersInput>>>;
};

export type ComponentEngravingEngravingInput = {
  Description?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  ImageToSend?: InputMaybe<Scalars['ID']['input']>;
  StartingDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentNavigationBanner = {
  __typename?: 'ComponentNavigationBanner';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentNavigationBannerItems>>>;
};


export type ComponentNavigationBannerItemsArgs = {
  filters?: InputMaybe<ComponentNavigationBannerItemsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentNavigationBannerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<ComponentNavigationBannerItemsInput>>>;
};

export type ComponentNavigationBannerItems = {
  __typename?: 'ComponentNavigationBannerItems';
  date_from: Scalars['DateTime']['output'];
  date_to: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ComponentNavigationBannerItemsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNavigationBannerItemsFiltersInput>>>;
  date_from?: InputMaybe<DateTimeFilterInput>;
  date_to?: InputMaybe<DateTimeFilterInput>;
  not?: InputMaybe<ComponentNavigationBannerItemsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNavigationBannerItemsFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentNavigationBannerItemsInput = {
  date_from?: InputMaybe<Scalars['DateTime']['input']>;
  date_to?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNavigationColumn = {
  __typename?: 'ComponentNavigationColumn';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentPartsLink>>>;
  link?: Maybe<ComponentPartsLink>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentNavigationColumnItemsArgs = {
  filters?: InputMaybe<ComponentPartsLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentNavigationColumnFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNavigationColumnFiltersInput>>>;
  items?: InputMaybe<ComponentPartsLinkFiltersInput>;
  link?: InputMaybe<ComponentPartsLinkFiltersInput>;
  not?: InputMaybe<ComponentNavigationColumnFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNavigationColumnFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentNavigationColumnInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<ComponentPartsLinkInput>>>;
  link?: InputMaybe<ComponentPartsLinkInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNavigationTopMenu = {
  __typename?: 'ComponentNavigationTopMenu';
  columns?: Maybe<Array<Maybe<ComponentNavigationColumn>>>;
  id: Scalars['ID']['output'];
  image?: Maybe<ComponentNavigationTopMenuImage>;
  link?: Maybe<ComponentPartsLink>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentNavigationTopMenuColumnsArgs = {
  filters?: InputMaybe<ComponentNavigationColumnFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentNavigationTopMenuFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNavigationTopMenuFiltersInput>>>;
  columns?: InputMaybe<ComponentNavigationColumnFiltersInput>;
  image?: InputMaybe<ComponentNavigationTopMenuImageFiltersInput>;
  link?: InputMaybe<ComponentPartsLinkFiltersInput>;
  not?: InputMaybe<ComponentNavigationTopMenuFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNavigationTopMenuFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentNavigationTopMenuImage = {
  __typename?: 'ComponentNavigationTopMenuImage';
  cta?: Maybe<ComponentPartsCta>;
  id: Scalars['ID']['output'];
  img?: Maybe<UploadFileEntityResponse>;
  link?: Maybe<ComponentPartsLink>;
};

export type ComponentNavigationTopMenuImageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNavigationTopMenuImageFiltersInput>>>;
  cta?: InputMaybe<ComponentPartsCtaFiltersInput>;
  link?: InputMaybe<ComponentPartsLinkFiltersInput>;
  not?: InputMaybe<ComponentNavigationTopMenuImageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNavigationTopMenuImageFiltersInput>>>;
};

export type ComponentNavigationTopMenuImageInput = {
  cta?: InputMaybe<ComponentPartsCtaInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  img?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<ComponentPartsLinkInput>;
};

export type ComponentNavigationTopMenuInput = {
  columns?: InputMaybe<Array<InputMaybe<ComponentNavigationColumnInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<ComponentNavigationTopMenuImageInput>;
  link?: InputMaybe<ComponentPartsLinkInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPartsBackground = {
  __typename?: 'ComponentPartsBackground';
  desktop: UploadFileEntityResponse;
  id: Scalars['ID']['output'];
  mobile: UploadFileEntityResponse;
};

export type ComponentPartsBackgroundInput = {
  desktop?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mobile?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentPartsCta = {
  __typename?: 'ComponentPartsCta';
  id: Scalars['ID']['output'];
  link?: Maybe<ComponentPartsLink>;
  reversed?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Enum_Componentpartscta_Variant>;
};

export type ComponentPartsCtaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsCtaFiltersInput>>>;
  link?: InputMaybe<ComponentPartsLinkFiltersInput>;
  not?: InputMaybe<ComponentPartsCtaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsCtaFiltersInput>>>;
  reversed?: InputMaybe<BooleanFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  variant?: InputMaybe<StringFilterInput>;
};

export type ComponentPartsCtaInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<ComponentPartsLinkInput>;
  reversed?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Enum_Componentpartscta_Variant>;
};

export type ComponentPartsDictionary = {
  __typename?: 'ComponentPartsDictionary';
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ComponentPartsDictionaryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsDictionaryFiltersInput>>>;
  key?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentPartsDictionaryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsDictionaryFiltersInput>>>;
  value?: InputMaybe<StringFilterInput>;
};

export type ComponentPartsGridItem = {
  __typename?: 'ComponentPartsGridItem';
  id: Scalars['ID']['output'];
  img: UploadFileEntityResponse;
  link?: Maybe<ComponentPartsLink>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentPartsGridItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsGridItemFiltersInput>>>;
  link?: InputMaybe<ComponentPartsLinkFiltersInput>;
  not?: InputMaybe<ComponentPartsGridItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsGridItemFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentPartsGridItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  img?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<ComponentPartsLinkInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPartsHeader = {
  __typename?: 'ComponentPartsHeader';
  bg?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  cover_navbar?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  img?: Maybe<UploadFileEntityResponse>;
  img_mobile?: Maybe<UploadFileEntityResponse>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentPartsHeaderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsHeaderFiltersInput>>>;
  bg?: InputMaybe<StringFilterInput>;
  color?: InputMaybe<StringFilterInput>;
  cover_navbar?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentPartsHeaderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsHeaderFiltersInput>>>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentPartsHeaderInput = {
  bg?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  cover_navbar?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  img?: InputMaybe<Scalars['ID']['input']>;
  img_mobile?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPartsLink = {
  __typename?: 'ComponentPartsLink';
  external_href?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rel?: Maybe<Enum_Componentpartslink_Rel>;
  target?: Maybe<Enum_Componentpartslink_Target>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ComponentPartsLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsLinkFiltersInput>>>;
  external_href?: InputMaybe<StringFilterInput>;
  href?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentPartsLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsLinkFiltersInput>>>;
  rel?: InputMaybe<StringFilterInput>;
  target?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentPartsLinkInput = {
  external_href?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  rel?: InputMaybe<Enum_Componentpartslink_Rel>;
  target?: InputMaybe<Enum_Componentpartslink_Target>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPartsOpinion = {
  __typename?: 'ComponentPartsOpinion';
  id: Scalars['ID']['output'];
  logo?: Maybe<UploadFileEntityResponse>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ComponentPartsOpinionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsOpinionFiltersInput>>>;
  not?: InputMaybe<ComponentPartsOpinionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsOpinionFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentPartsOpinionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPartsProduct = {
  __typename?: 'ComponentPartsProduct';
  id: Scalars['ID']['output'];
  url_key?: Maybe<Scalars['String']['output']>;
};

export type ComponentPartsProductFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsProductFiltersInput>>>;
  not?: InputMaybe<ComponentPartsProductFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsProductFiltersInput>>>;
  url_key?: InputMaybe<StringFilterInput>;
};

export type ComponentPartsProductInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  url_key?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPartsQuestionFaq = {
  __typename?: 'ComponentPartsQuestionFaq';
  answer?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Enum_Componentpartsquestionfaq_Group>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type ComponentPartsQuestionFaqFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsQuestionFaqFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  group?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentPartsQuestionFaqFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsQuestionFaqFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentPartsRedirect = {
  __typename?: 'ComponentPartsRedirect';
  enabled: Scalars['Boolean']['output'];
  from: Scalars['String']['output'];
  http_status: Http_Status;
  id: Scalars['ID']['output'];
  to: Scalars['String']['output'];
};

export type ComponentPartsRedirectFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsRedirectFiltersInput>>>;
  enabled?: InputMaybe<BooleanFilterInput>;
  from?: InputMaybe<StringFilterInput>;
  http_status?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentPartsRedirectFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsRedirectFiltersInput>>>;
  to?: InputMaybe<StringFilterInput>;
};

export type ComponentPartsRedirectInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  http_status?: InputMaybe<Http_Status>;
  id?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPartsSeo = {
  __typename?: 'ComponentPartsSeo';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ComponentPartsSeoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsSeoFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentPartsSeoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsSeoFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentPartsSeoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPartsShipmentPrice = {
  __typename?: 'ComponentPartsShipmentPrice';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ComponentPartsShipmentPriceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsShipmentPriceFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentPartsShipmentPriceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsShipmentPriceFiltersInput>>>;
  value?: InputMaybe<StringFilterInput>;
};

export type ComponentPartsStoryItem = {
  __typename?: 'ComponentPartsStoryItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  img?: Maybe<UploadFileEntityResponse>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ComponentPartsStoryItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPartsStoryItemFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentPartsStoryItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPartsStoryItemFiltersInput>>>;
  year?: InputMaybe<IntFilterInput>;
};

export type ComponentRelationsInspiration = {
  __typename?: 'ComponentRelationsInspiration';
  id: Scalars['ID']['output'];
  inspiration?: Maybe<InspirationEntityResponse>;
};

export type ComponentRelationsInspirationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentRelationsInspirationFiltersInput>>>;
  inspiration?: InputMaybe<InspirationFiltersInput>;
  not?: InputMaybe<ComponentRelationsInspirationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentRelationsInspirationFiltersInput>>>;
};

export type ComponentSectionsBanner = {
  __typename?: 'ComponentSectionsBanner';
  alignment?: Maybe<Enum_Componentsectionsbanner_Alignment>;
  bg?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  cta?: Maybe<ComponentPartsCta>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  img: UploadFileEntityResponse;
  img_mobile?: Maybe<UploadFileEntityResponse>;
  link?: Maybe<ComponentPartsCta>;
  section_title?: Maybe<Scalars['String']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export type ComponentSectionsBannerFiltersInput = {
  alignment?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSectionsBannerFiltersInput>>>;
  bg?: InputMaybe<StringFilterInput>;
  color?: InputMaybe<StringFilterInput>;
  cta?: InputMaybe<ComponentPartsCtaFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  link?: InputMaybe<ComponentPartsCtaFiltersInput>;
  not?: InputMaybe<ComponentSectionsBannerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSectionsBannerFiltersInput>>>;
  section_title?: InputMaybe<StringFilterInput>;
  short_description?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  variant?: InputMaybe<StringFilterInput>;
};

export type ComponentSectionsBannerInput = {
  alignment?: InputMaybe<Enum_Componentsectionsbanner_Alignment>;
  bg?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  cta?: InputMaybe<ComponentPartsCtaInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  img?: InputMaybe<Scalars['ID']['input']>;
  img_mobile?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<ComponentPartsCtaInput>;
  section_title?: InputMaybe<Scalars['String']['input']>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSectionsContentSection = {
  __typename?: 'ComponentSectionsContentSection';
  bg_color?: Maybe<Scalars['String']['output']>;
  cta?: Maybe<ComponentPartsCta>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  img: UploadFileEntityResponse;
  img_mobile?: Maybe<UploadFileEntityResponse>;
  img_position?: Maybe<Enum_Componentsectionscontentsection_Img_Position>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentSectionsGrid = {
  __typename?: 'ComponentSectionsGrid';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentPartsGridItem>>>;
  section_title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


export type ComponentSectionsGridItemsArgs = {
  filters?: InputMaybe<ComponentPartsGridItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSectionsGridInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<ComponentPartsGridItemInput>>>;
  section_title?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSectionsInstashop = {
  __typename?: 'ComponentSectionsInstashop';
  body_script?: Maybe<Scalars['String']['output']>;
  head_script?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  section_title?: Maybe<Scalars['String']['output']>;
};

export type ComponentSectionsProductsList = {
  __typename?: 'ComponentSectionsProductsList';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentPartsProduct>>>;
  rows?: Maybe<Scalars['Int']['output']>;
  section_title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSectionsProductsListItemsArgs = {
  filters?: InputMaybe<ComponentPartsProductFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSectionsProductsListInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<ComponentPartsProductInput>>>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  section_title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSectionsRichtext = {
  __typename?: 'ComponentSectionsRichtext';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type ComponentSectionsSlider = {
  __typename?: 'ComponentSectionsSlider';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentSectionsBanner>>>;
};


export type ComponentSectionsSliderItemsArgs = {
  filters?: InputMaybe<ComponentSectionsBannerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSectionsStorySection = {
  __typename?: 'ComponentSectionsStorySection';
  author?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  img: UploadFileEntityResponse;
  img_mobile?: Maybe<UploadFileEntityResponse>;
  story_img_position?: Maybe<Enum_Componentsectionsstorysection_Story_Img_Position>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentSectionsVideo = {
  __typename?: 'ComponentSectionsVideo';
  id: Scalars['ID']['output'];
  section_title?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export type ComponentSectionsVideoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  section_title?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSpecialCustomComponent = {
  __typename?: 'ComponentSpecialCustomComponent';
  component_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSpecialFaq = {
  __typename?: 'ComponentSpecialFaq';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentPartsQuestionFaq>>>;
};


export type ComponentSpecialFaqItemsArgs = {
  filters?: InputMaybe<ComponentPartsQuestionFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSpecialInspirationsGrid = {
  __typename?: 'ComponentSpecialInspirationsGrid';
  id: Scalars['ID']['output'];
  inspirations?: Maybe<InspirationRelationResponseCollection>;
  item?: Maybe<Array<Maybe<ComponentRelationsInspiration>>>;
};


export type ComponentSpecialInspirationsGridInspirationsArgs = {
  filters?: InputMaybe<InspirationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSpecialInspirationsGridItemArgs = {
  filters?: InputMaybe<ComponentRelationsInspirationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSpecialNewsletter = {
  __typename?: 'ComponentSpecialNewsletter';
  close_btn?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_2?: Maybe<Scalars['String']['output']>;
  cta?: Maybe<ComponentPartsCta>;
  description?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  header_2?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  img: UploadFileEntityResponse;
  img_2: UploadFileEntityResponse;
  img_mobile?: Maybe<UploadFileEntityResponse>;
  short_content?: Maybe<Scalars['String']['output']>;
  submit_btn?: Maybe<Scalars['String']['output']>;
  terms_and_conditions?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentSpecialOpinionsSlider = {
  __typename?: 'ComponentSpecialOpinionsSlider';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentPartsOpinion>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSpecialOpinionsSliderItemsArgs = {
  filters?: InputMaybe<ComponentPartsOpinionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSpecialOpinionsSliderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  items?: InputMaybe<Array<InputMaybe<ComponentPartsOpinionInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSpecialShipmentTable = {
  __typename?: 'ComponentSpecialShipmentTable';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentPartsShipmentPrice>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSpecialShipmentTableItemsArgs = {
  filters?: InputMaybe<ComponentPartsShipmentPriceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSpecialStoryCarousel = {
  __typename?: 'ComponentSpecialStoryCarousel';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentPartsStoryItem>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSpecialStoryCarouselItemsArgs = {
  filters?: InputMaybe<ComponentPartsStoryItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSpecialTalismansSection = {
  __typename?: 'ComponentSpecialTalismansSection';
  content_section_stone?: Maybe<ComponentSectionsContentSection>;
  content_section_zodiac?: Maybe<ComponentSectionsContentSection>;
  id: Scalars['ID']['output'];
  kamienie_swatch?: Maybe<Array<Maybe<ComponentPartsDictionary>>>;
  products_list_stone?: Maybe<ComponentSectionsProductsList>;
  products_list_zodiac?: Maybe<ComponentSectionsProductsList>;
};


export type ComponentSpecialTalismansSectionKamienie_SwatchArgs = {
  filters?: InputMaybe<ComponentPartsDictionaryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentStartPageRedirect = {
  __typename?: 'ComponentStartPageRedirect';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ComponentStartPageRedirectFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentStartPageRedirectFiltersInput>>>;
  enabled?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentStartPageRedirectFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentStartPageRedirectFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentStartPageRedirectInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPage = {
  __typename?: 'ContactPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ContactPageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactPageEntity = {
  __typename?: 'ContactPageEntity';
  attributes?: Maybe<ContactPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ContactPageEntityResponse = {
  __typename?: 'ContactPageEntityResponse';
  data?: Maybe<ContactPageEntity>;
};

export type ContactPageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPageRelationResponseCollection = {
  __typename?: 'ContactPageRelationResponseCollection';
  data: Array<ContactPageEntity>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Enum_Blogpost_Category {
  Events = 'events',
  Fashion = 'fashion',
  News = 'news',
  Tips = 'tips'
}

export enum Enum_Componentpartscta_Variant {
  Outline = 'outline',
  Solid = 'solid'
}

export enum Enum_Componentpartslink_Rel {
  Alternate = 'alternate',
  Author = 'author',
  Bookmark = 'bookmark',
  Canonical = 'canonical',
  DnsPrefetch = 'dns_prefetch',
  External = 'external',
  Help = 'help',
  Icon = 'icon',
  License = 'license',
  Manifest = 'manifest',
  Me = 'me',
  Modulepreload = 'modulepreload',
  Next = 'next',
  Nofollow = 'nofollow',
  Noopener = 'noopener',
  Noreferrer = 'noreferrer',
  Opener = 'opener',
  Pingback = 'pingback',
  Preconnect = 'preconnect',
  Prefetch = 'prefetch',
  Preload = 'preload',
  Prerender = 'prerender',
  Prev = 'prev',
  Search = 'search',
  Stylesheet = 'stylesheet',
  Tag = 'tag'
}

export enum Enum_Componentpartslink_Target {
  Blank = 'blank',
  Parent = 'parent',
  Self = 'self',
  Top = 'top'
}

export enum Enum_Componentpartsquestionfaq_Group {
  DostawaIPlatnosc = 'dostawa_i_platnosc',
  GrawerunekIMalowanie = 'grawerunek_i_malowanie',
  Inne = 'inne',
  PersonalizacjaIUslugiDodatkowe = 'personalizacja_i_uslugi_dodatkowe',
  PielegnacjaIUzytkowanieBizuterii = 'pielegnacja_i_uzytkowanie_bizuterii',
  WyborRozmiaruIRegulacjaBransoletek = 'wybor_rozmiaru_i_regulacja_bransoletek',
  ZamowieniaInternetowe = 'zamowienia_internetowe',
  ZwrotyIReklamacje = 'zwroty_i_reklamacje'
}

export enum Enum_Componentsectionsbanner_Alignment {
  End = 'end',
  Start = 'start'
}

export enum Enum_Componentsectionscontentsection_Img_Position {
  Left = 'left',
  Right = 'right'
}

export enum Enum_Componentsectionsstorysection_Story_Img_Position {
  Left = 'left',
  Right = 'right'
}

export type Engraving = {
  __typename?: 'Engraving';
  CategoryName: Scalars['String']['output'];
  Engravings: Array<Maybe<ComponentEngravingEngraving>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<EngravingRelationResponseCollection>;
  order?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type EngravingEngravingsArgs = {
  filters?: InputMaybe<ComponentEngravingEngravingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EngravingLocalizationsArgs = {
  filters?: InputMaybe<EngravingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EngravingEntity = {
  __typename?: 'EngravingEntity';
  attributes?: Maybe<Engraving>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EngravingEntityResponse = {
  __typename?: 'EngravingEntityResponse';
  data?: Maybe<EngravingEntity>;
};

export type EngravingEntityResponseCollection = {
  __typename?: 'EngravingEntityResponseCollection';
  data: Array<EngravingEntity>;
  meta: ResponseCollectionMeta;
};

export type EngravingFiltersInput = {
  CategoryName?: InputMaybe<StringFilterInput>;
  Engravings?: InputMaybe<ComponentEngravingEngravingFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<EngravingFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<EngravingFiltersInput>;
  not?: InputMaybe<EngravingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EngravingFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EngravingInput = {
  CategoryName?: InputMaybe<Scalars['String']['input']>;
  Engravings?: InputMaybe<Array<InputMaybe<ComponentEngravingEngravingInput>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EngravingRelationResponseCollection = {
  __typename?: 'EngravingRelationResponseCollection';
  data: Array<EngravingEntity>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type Footer = {
  __typename?: 'Footer';
  columns?: Maybe<Array<Maybe<ComponentNavigationColumn>>>;
  company?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<FooterRelationResponseCollection>;
  social_media?: Maybe<Array<Maybe<ComponentPartsLink>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type FooterColumnsArgs = {
  filters?: InputMaybe<ComponentNavigationColumnFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FooterSocial_MediaArgs = {
  filters?: InputMaybe<ComponentPartsLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FooterEntity = {
  __typename?: 'FooterEntity';
  attributes?: Maybe<Footer>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FooterEntityResponse = {
  __typename?: 'FooterEntityResponse';
  data?: Maybe<FooterEntity>;
};

export type FooterInput = {
  columns?: InputMaybe<Array<InputMaybe<ComponentNavigationColumnInput>>>;
  company?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  social_media?: InputMaybe<Array<InputMaybe<ComponentPartsLinkInput>>>;
};

export type FooterRelationResponseCollection = {
  __typename?: 'FooterRelationResponseCollection';
  data: Array<FooterEntity>;
};

export type GenericMorph = AboutPage | BlogPost | Cart | ComponentCartCartBanner | ComponentCartItem | ComponentEngravingEngraving | ComponentNavigationBanner | ComponentNavigationBannerItems | ComponentNavigationColumn | ComponentNavigationTopMenu | ComponentNavigationTopMenuImage | ComponentPartsBackground | ComponentPartsCta | ComponentPartsDictionary | ComponentPartsGridItem | ComponentPartsHeader | ComponentPartsLink | ComponentPartsOpinion | ComponentPartsProduct | ComponentPartsQuestionFaq | ComponentPartsRedirect | ComponentPartsSeo | ComponentPartsShipmentPrice | ComponentPartsStoryItem | ComponentRelationsInspiration | ComponentSectionsBanner | ComponentSectionsContentSection | ComponentSectionsGrid | ComponentSectionsInstashop | ComponentSectionsProductsList | ComponentSectionsRichtext | ComponentSectionsSlider | ComponentSectionsStorySection | ComponentSectionsVideo | ComponentSpecialCustomComponent | ComponentSpecialFaq | ComponentSpecialInspirationsGrid | ComponentSpecialNewsletter | ComponentSpecialOpinionsSlider | ComponentSpecialShipmentTable | ComponentSpecialStoryCarousel | ComponentSpecialTalismansSection | ComponentStartPageRedirect | ContactPage | Engraving | Footer | HomePage | I18NLocale | Information | Inspiration | InspirationsHub | Intention | Listing | MetaTag | Navigation | NewsletterBanner | Page | Product | Redirect | StartPage | TestPage | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | WelcomeConfigurator;

export type HomePage = {
  __typename?: 'HomePage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hero?: Maybe<Array<Maybe<ComponentSectionsBanner>>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<HomePageRelationResponseCollection>;
  opinions?: Maybe<ComponentSpecialOpinionsSlider>;
  sections?: Maybe<Array<Maybe<HomePageSectionsDynamicZone>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  video_mobile?: Maybe<ComponentSectionsVideo>;
};


export type HomePageHeroArgs = {
  filters?: InputMaybe<ComponentSectionsBannerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HomePageEntity = {
  __typename?: 'HomePageEntity';
  attributes?: Maybe<HomePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type HomePageEntityResponse = {
  __typename?: 'HomePageEntityResponse';
  data?: Maybe<HomePageEntity>;
};

export type HomePageInput = {
  hero?: InputMaybe<Array<InputMaybe<ComponentSectionsBannerInput>>>;
  opinions?: InputMaybe<ComponentSpecialOpinionsSliderInput>;
  sections?: InputMaybe<Array<Scalars['HomePageSectionsDynamicZoneInput']['input']>>;
  video_mobile?: InputMaybe<ComponentSectionsVideoInput>;
};

export type HomePageRelationResponseCollection = {
  __typename?: 'HomePageRelationResponseCollection';
  data: Array<HomePageEntity>;
};

export type HomePageSectionsDynamicZone = ComponentSectionsBanner | ComponentSectionsGrid | ComponentSectionsInstashop | ComponentSectionsProductsList | ComponentSectionsSlider | ComponentSectionsVideo | Error;

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type Information = {
  __typename?: 'Information';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<InformationRelationResponseCollection>;
  order?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<PageEntityResponse>;
  sections?: Maybe<Array<Maybe<InformationSectionsDynamicZone>>>;
  seo?: Maybe<ComponentPartsSeo>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type InformationLocalizationsArgs = {
  filters?: InputMaybe<InformationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InformationEntity = {
  __typename?: 'InformationEntity';
  attributes?: Maybe<Information>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InformationEntityResponse = {
  __typename?: 'InformationEntityResponse';
  data?: Maybe<InformationEntity>;
};

export type InformationEntityResponseCollection = {
  __typename?: 'InformationEntityResponseCollection';
  data: Array<InformationEntity>;
  meta: ResponseCollectionMeta;
};

export type InformationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InformationFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<InformationFiltersInput>;
  not?: InputMaybe<InformationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InformationFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  page?: InputMaybe<PageFiltersInput>;
  seo?: InputMaybe<ComponentPartsSeoFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type InformationInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['ID']['input']>;
  sections?: InputMaybe<Array<Scalars['InformationSectionsDynamicZoneInput']['input']>>;
  seo?: InputMaybe<ComponentPartsSeoInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type InformationRelationResponseCollection = {
  __typename?: 'InformationRelationResponseCollection';
  data: Array<InformationEntity>;
};

export type InformationSectionsDynamicZone = ComponentPartsCta | ComponentSectionsRichtext | ComponentSpecialFaq | ComponentSpecialShipmentTable | Error;

export type Inspiration = {
  __typename?: 'Inspiration';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  header: ComponentPartsHeader;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<InspirationRelationResponseCollection>;
  page?: Maybe<PageEntityResponse>;
  sections?: Maybe<Array<Maybe<InspirationSectionsDynamicZone>>>;
  seo: ComponentPartsSeo;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type InspirationLocalizationsArgs = {
  filters?: InputMaybe<InspirationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InspirationEntity = {
  __typename?: 'InspirationEntity';
  attributes?: Maybe<Inspiration>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InspirationEntityResponse = {
  __typename?: 'InspirationEntityResponse';
  data?: Maybe<InspirationEntity>;
};

export type InspirationEntityResponseCollection = {
  __typename?: 'InspirationEntityResponseCollection';
  data: Array<InspirationEntity>;
  meta: ResponseCollectionMeta;
};

export type InspirationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InspirationFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  header?: InputMaybe<ComponentPartsHeaderFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<InspirationFiltersInput>;
  not?: InputMaybe<InspirationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InspirationFiltersInput>>>;
  page?: InputMaybe<PageFiltersInput>;
  seo?: InputMaybe<ComponentPartsSeoFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type InspirationInput = {
  header?: InputMaybe<ComponentPartsHeaderInput>;
  page?: InputMaybe<Scalars['ID']['input']>;
  sections?: InputMaybe<Array<Scalars['InspirationSectionsDynamicZoneInput']['input']>>;
  seo?: InputMaybe<ComponentPartsSeoInput>;
};

export type InspirationRelationResponseCollection = {
  __typename?: 'InspirationRelationResponseCollection';
  data: Array<InspirationEntity>;
};

export type InspirationSectionsDynamicZone = ComponentSectionsBanner | ComponentSectionsContentSection | ComponentSectionsProductsList | ComponentSectionsRichtext | ComponentSectionsStorySection | ComponentSpecialCustomComponent | ComponentSpecialTalismansSection | Error;

export type InspirationsHub = {
  __typename?: 'InspirationsHub';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  header?: Maybe<ComponentPartsHeader>;
  items?: Maybe<ComponentSectionsGrid>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<InspirationsHubRelationResponseCollection>;
  seo?: Maybe<ComponentPartsSeo>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InspirationsHubEntity = {
  __typename?: 'InspirationsHubEntity';
  attributes?: Maybe<InspirationsHub>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InspirationsHubEntityResponse = {
  __typename?: 'InspirationsHubEntityResponse';
  data?: Maybe<InspirationsHubEntity>;
};

export type InspirationsHubInput = {
  header?: InputMaybe<ComponentPartsHeaderInput>;
  items?: InputMaybe<ComponentSectionsGridInput>;
  seo?: InputMaybe<ComponentPartsSeoInput>;
};

export type InspirationsHubRelationResponseCollection = {
  __typename?: 'InspirationsHubRelationResponseCollection';
  data: Array<InspirationsHubEntity>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type Intention = {
  __typename?: 'Intention';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  items_abundance?: Maybe<ComponentSectionsProductsList>;
  items_health?: Maybe<ComponentSectionsProductsList>;
  items_joy?: Maybe<ComponentSectionsProductsList>;
  items_love?: Maybe<ComponentSectionsProductsList>;
  items_protection?: Maybe<ComponentSectionsProductsList>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<IntentionRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IntentionEntity = {
  __typename?: 'IntentionEntity';
  attributes?: Maybe<Intention>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type IntentionEntityResponse = {
  __typename?: 'IntentionEntityResponse';
  data?: Maybe<IntentionEntity>;
};

export type IntentionInput = {
  items_abundance?: InputMaybe<ComponentSectionsProductsListInput>;
  items_health?: InputMaybe<ComponentSectionsProductsListInput>;
  items_joy?: InputMaybe<ComponentSectionsProductsListInput>;
  items_love?: InputMaybe<ComponentSectionsProductsListInput>;
  items_protection?: InputMaybe<ComponentSectionsProductsListInput>;
};

export type IntentionRelationResponseCollection = {
  __typename?: 'IntentionRelationResponseCollection';
  data: Array<IntentionEntity>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type Listing = {
  __typename?: 'Listing';
  cover_image?: Maybe<UploadFileEntityResponse>;
  cover_image_mobile?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  description_title?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ListingRelationResponseCollection>;
  magento_url_path?: Maybe<Scalars['String']['output']>;
  page?: Maybe<PageEntityResponse>;
  sections?: Maybe<Array<Maybe<ListingSectionsDynamicZone>>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ListingLocalizationsArgs = {
  filters?: InputMaybe<ListingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ListingEntity = {
  __typename?: 'ListingEntity';
  attributes?: Maybe<Listing>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ListingEntityResponse = {
  __typename?: 'ListingEntityResponse';
  data?: Maybe<ListingEntity>;
};

export type ListingEntityResponseCollection = {
  __typename?: 'ListingEntityResponseCollection';
  data: Array<ListingEntity>;
  meta: ResponseCollectionMeta;
};

export type ListingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ListingFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  description_title?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ListingFiltersInput>;
  magento_url_path?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ListingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ListingFiltersInput>>>;
  page?: InputMaybe<PageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ListingInput = {
  cover_image?: InputMaybe<Scalars['ID']['input']>;
  cover_image_mobile?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_title?: InputMaybe<Scalars['String']['input']>;
  magento_url_path?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['ID']['input']>;
  sections?: InputMaybe<Array<Scalars['ListingSectionsDynamicZoneInput']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ListingRelationResponseCollection = {
  __typename?: 'ListingRelationResponseCollection';
  data: Array<ListingEntity>;
};

export type ListingSectionsDynamicZone = ComponentSectionsBanner | ComponentSectionsContentSection | Error;

export type MetaTag = {
  __typename?: 'MetaTag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  noFollow?: Maybe<Scalars['Boolean']['output']>;
  noIndex?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url_key: Scalars['String']['output'];
};

export type MetaTagEntity = {
  __typename?: 'MetaTagEntity';
  attributes?: Maybe<MetaTag>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MetaTagEntityResponse = {
  __typename?: 'MetaTagEntityResponse';
  data?: Maybe<MetaTagEntity>;
};

export type MetaTagEntityResponseCollection = {
  __typename?: 'MetaTagEntityResponseCollection';
  data: Array<MetaTagEntity>;
  meta: ResponseCollectionMeta;
};

export type MetaTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MetaTagFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  noFollow?: InputMaybe<BooleanFilterInput>;
  noIndex?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<MetaTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MetaTagFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url_key?: InputMaybe<StringFilterInput>;
};

export type MetaTagInput = {
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  url_key?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAboutPageLocalization?: Maybe<AboutPageEntityResponse>;
  createBlogPost?: Maybe<BlogPostEntityResponse>;
  createBlogPostLocalization?: Maybe<BlogPostEntityResponse>;
  createCartLocalization?: Maybe<CartEntityResponse>;
  createContactPageLocalization?: Maybe<ContactPageEntityResponse>;
  createEngraving?: Maybe<EngravingEntityResponse>;
  createEngravingLocalization?: Maybe<EngravingEntityResponse>;
  createFooterLocalization?: Maybe<FooterEntityResponse>;
  createHomePageLocalization?: Maybe<HomePageEntityResponse>;
  createInformation?: Maybe<InformationEntityResponse>;
  createInformationLocalization?: Maybe<InformationEntityResponse>;
  createInspiration?: Maybe<InspirationEntityResponse>;
  createInspirationLocalization?: Maybe<InspirationEntityResponse>;
  createInspirationsHubLocalization?: Maybe<InspirationsHubEntityResponse>;
  createIntentionLocalization?: Maybe<IntentionEntityResponse>;
  createListing?: Maybe<ListingEntityResponse>;
  createListingLocalization?: Maybe<ListingEntityResponse>;
  createMetaTag?: Maybe<MetaTagEntityResponse>;
  createNavigationLocalization?: Maybe<NavigationEntityResponse>;
  createNewsletterBannerLocalization?: Maybe<NewsletterBannerEntityResponse>;
  createPage?: Maybe<PageEntityResponse>;
  createProductLocalization?: Maybe<ProductEntityResponse>;
  createRedirect?: Maybe<RedirectEntityResponse>;
  createStartPageLocalization?: Maybe<StartPageEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  createWelcomeConfiguratorLocalization?: Maybe<WelcomeConfiguratorEntityResponse>;
  deleteAboutPage?: Maybe<AboutPageEntityResponse>;
  deleteBlogPost?: Maybe<BlogPostEntityResponse>;
  deleteCart?: Maybe<CartEntityResponse>;
  deleteContactPage?: Maybe<ContactPageEntityResponse>;
  deleteEngraving?: Maybe<EngravingEntityResponse>;
  deleteFooter?: Maybe<FooterEntityResponse>;
  deleteHomePage?: Maybe<HomePageEntityResponse>;
  deleteInformation?: Maybe<InformationEntityResponse>;
  deleteInspiration?: Maybe<InspirationEntityResponse>;
  deleteInspirationsHub?: Maybe<InspirationsHubEntityResponse>;
  deleteIntention?: Maybe<IntentionEntityResponse>;
  deleteListing?: Maybe<ListingEntityResponse>;
  deleteMetaTag?: Maybe<MetaTagEntityResponse>;
  deleteNavigation?: Maybe<NavigationEntityResponse>;
  deleteNewsletterBanner?: Maybe<NewsletterBannerEntityResponse>;
  deletePage?: Maybe<PageEntityResponse>;
  deleteProduct?: Maybe<ProductEntityResponse>;
  deleteRedirect?: Maybe<RedirectEntityResponse>;
  deleteStartPage?: Maybe<StartPageEntityResponse>;
  deleteTestPage?: Maybe<TestPageEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteWelcomeConfigurator?: Maybe<WelcomeConfiguratorEntityResponse>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateAboutPage?: Maybe<AboutPageEntityResponse>;
  updateBlogPost?: Maybe<BlogPostEntityResponse>;
  updateCart?: Maybe<CartEntityResponse>;
  updateContactPage?: Maybe<ContactPageEntityResponse>;
  updateEngraving?: Maybe<EngravingEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateFooter?: Maybe<FooterEntityResponse>;
  updateHomePage?: Maybe<HomePageEntityResponse>;
  updateInformation?: Maybe<InformationEntityResponse>;
  updateInspiration?: Maybe<InspirationEntityResponse>;
  updateInspirationsHub?: Maybe<InspirationsHubEntityResponse>;
  updateIntention?: Maybe<IntentionEntityResponse>;
  updateListing?: Maybe<ListingEntityResponse>;
  updateMetaTag?: Maybe<MetaTagEntityResponse>;
  updateNavigation?: Maybe<NavigationEntityResponse>;
  updateNewsletterBanner?: Maybe<NewsletterBannerEntityResponse>;
  updatePage?: Maybe<PageEntityResponse>;
  updateProduct?: Maybe<ProductEntityResponse>;
  updateRedirect?: Maybe<RedirectEntityResponse>;
  updateStartPage?: Maybe<StartPageEntityResponse>;
  updateTestPage?: Maybe<TestPageEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateWelcomeConfigurator?: Maybe<WelcomeConfiguratorEntityResponse>;
  upload: UploadFileEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateAboutPageLocalizationArgs = {
  data?: InputMaybe<AboutPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogPostArgs = {
  data: BlogPostInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogPostLocalizationArgs = {
  data?: InputMaybe<BlogPostInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateCartLocalizationArgs = {
  data?: InputMaybe<CartInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateContactPageLocalizationArgs = {
  data?: InputMaybe<ContactPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateEngravingArgs = {
  data: EngravingInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateEngravingLocalizationArgs = {
  data?: InputMaybe<EngravingInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateFooterLocalizationArgs = {
  data?: InputMaybe<FooterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateHomePageLocalizationArgs = {
  data?: InputMaybe<HomePageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateInformationArgs = {
  data: InformationInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateInformationLocalizationArgs = {
  data?: InputMaybe<InformationInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateInspirationArgs = {
  data: InspirationInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateInspirationLocalizationArgs = {
  data?: InputMaybe<InspirationInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateInspirationsHubLocalizationArgs = {
  data?: InputMaybe<InspirationsHubInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateIntentionLocalizationArgs = {
  data?: InputMaybe<IntentionInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateListingArgs = {
  data: ListingInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateListingLocalizationArgs = {
  data?: InputMaybe<ListingInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateMetaTagArgs = {
  data: MetaTagInput;
};


export type MutationCreateNavigationLocalizationArgs = {
  data?: InputMaybe<NavigationInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateNewsletterBannerLocalizationArgs = {
  data?: InputMaybe<NewsletterBannerInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePageArgs = {
  data: PageInput;
};


export type MutationCreateProductLocalizationArgs = {
  data?: InputMaybe<ProductInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateRedirectArgs = {
  data: RedirectInput;
};


export type MutationCreateStartPageLocalizationArgs = {
  data?: InputMaybe<StartPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationCreateWelcomeConfiguratorLocalizationArgs = {
  data?: InputMaybe<WelcomeConfiguratorInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteAboutPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteBlogPostArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteCartArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteContactPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteEngravingArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteFooterArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteHomePageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteInformationArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteInspirationArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteInspirationsHubArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteIntentionArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteListingArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteMetaTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNavigationArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteNewsletterBannerArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeletePageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteRedirectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStartPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWelcomeConfiguratorArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateAboutPageArgs = {
  data: AboutPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateBlogPostArgs = {
  data: BlogPostInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateCartArgs = {
  data: CartInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateContactPageArgs = {
  data: ContactPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateEngravingArgs = {
  data: EngravingInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateFooterArgs = {
  data: FooterInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateHomePageArgs = {
  data: HomePageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateInformationArgs = {
  data: InformationInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateInspirationArgs = {
  data: InspirationInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateInspirationsHubArgs = {
  data: InspirationsHubInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateIntentionArgs = {
  data: IntentionInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateListingArgs = {
  data: ListingInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateMetaTagArgs = {
  data: MetaTagInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateNavigationArgs = {
  data: NavigationInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateNewsletterBannerArgs = {
  data: NewsletterBannerInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdatePageArgs = {
  data: PageInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateProductArgs = {
  data: ProductInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateRedirectArgs = {
  data: RedirectInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateStartPageArgs = {
  data: StartPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateTestPageArgs = {
  data: TestPageInput;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateWelcomeConfiguratorArgs = {
  data: WelcomeConfiguratorInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type Navigation = {
  __typename?: 'Navigation';
  banner?: Maybe<ComponentNavigationBanner>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<NavigationRelationResponseCollection>;
  top_menu?: Maybe<Array<Maybe<ComponentNavigationTopMenu>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type NavigationTop_MenuArgs = {
  filters?: InputMaybe<ComponentNavigationTopMenuFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NavigationEntity = {
  __typename?: 'NavigationEntity';
  attributes?: Maybe<Navigation>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NavigationEntityResponse = {
  __typename?: 'NavigationEntityResponse';
  data?: Maybe<NavigationEntity>;
};

export type NavigationInput = {
  banner?: InputMaybe<ComponentNavigationBannerInput>;
  top_menu?: InputMaybe<Array<InputMaybe<ComponentNavigationTopMenuInput>>>;
};

export type NavigationRelationResponseCollection = {
  __typename?: 'NavigationRelationResponseCollection';
  data: Array<NavigationEntity>;
};

export type NewsletterBanner = {
  __typename?: 'NewsletterBanner';
  close_btn?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_2?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cta?: Maybe<ComponentPartsCta>;
  description?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  header_2?: Maybe<Scalars['String']['output']>;
  img: UploadFileEntityResponse;
  img_2: UploadFileEntityResponse;
  img_mobile?: Maybe<UploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<NewsletterBannerRelationResponseCollection>;
  short_content?: Maybe<Scalars['String']['output']>;
  submit_btn?: Maybe<Scalars['String']['output']>;
  terms_and_conditions?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NewsletterBannerEntity = {
  __typename?: 'NewsletterBannerEntity';
  attributes?: Maybe<NewsletterBanner>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NewsletterBannerEntityResponse = {
  __typename?: 'NewsletterBannerEntityResponse';
  data?: Maybe<NewsletterBannerEntity>;
};

export type NewsletterBannerInput = {
  close_btn?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_2?: InputMaybe<Scalars['String']['input']>;
  cta?: InputMaybe<ComponentPartsCtaInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_2?: InputMaybe<Scalars['String']['input']>;
  img?: InputMaybe<Scalars['ID']['input']>;
  img_2?: InputMaybe<Scalars['ID']['input']>;
  img_mobile?: InputMaybe<Scalars['ID']['input']>;
  short_content?: InputMaybe<Scalars['String']['input']>;
  submit_btn?: InputMaybe<Scalars['String']['input']>;
  terms_and_conditions?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterBannerRelationResponseCollection = {
  __typename?: 'NewsletterBannerRelationResponseCollection';
  data: Array<NewsletterBannerEntity>;
};

export type Page = {
  __typename?: 'Page';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  url_key: Scalars['String']['output'];
};

export type PageEntity = {
  __typename?: 'PageEntity';
  attributes?: Maybe<Page>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PageEntityResponse = {
  __typename?: 'PageEntityResponse';
  data?: Maybe<PageEntity>;
};

export type PageEntityResponseCollection = {
  __typename?: 'PageEntityResponseCollection';
  data: Array<PageEntity>;
  meta: ResponseCollectionMeta;
};

export type PageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  url_key?: InputMaybe<StringFilterInput>;
};

export type PageInput = {
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_key?: InputMaybe<Scalars['String']['input']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Product = {
  __typename?: 'Product';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ProductRelationResponseCollection>;
  pdp_video_desktop?: Maybe<ComponentSectionsVideo>;
  pdp_video_mobile?: Maybe<ComponentSectionsVideo>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductEntity = {
  __typename?: 'ProductEntity';
  attributes?: Maybe<Product>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ProductEntityResponse = {
  __typename?: 'ProductEntityResponse';
  data?: Maybe<ProductEntity>;
};

export type ProductInput = {
  pdp_video_desktop?: InputMaybe<ComponentSectionsVideoInput>;
  pdp_video_mobile?: InputMaybe<ComponentSectionsVideoInput>;
};

export type ProductRelationResponseCollection = {
  __typename?: 'ProductRelationResponseCollection';
  data: Array<ProductEntity>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  aboutPage?: Maybe<AboutPageEntityResponse>;
  blogPost?: Maybe<BlogPostEntityResponse>;
  blogPosts?: Maybe<BlogPostEntityResponseCollection>;
  cart?: Maybe<CartEntityResponse>;
  contactPage?: Maybe<ContactPageEntityResponse>;
  engraving?: Maybe<EngravingEntityResponse>;
  engravings?: Maybe<EngravingEntityResponseCollection>;
  footer?: Maybe<FooterEntityResponse>;
  homePage?: Maybe<HomePageEntityResponse>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  information?: Maybe<InformationEntityResponse>;
  informations?: Maybe<InformationEntityResponseCollection>;
  inspiration?: Maybe<InspirationEntityResponse>;
  inspirations?: Maybe<InspirationEntityResponseCollection>;
  inspirationsHub?: Maybe<InspirationsHubEntityResponse>;
  intention?: Maybe<IntentionEntityResponse>;
  listing?: Maybe<ListingEntityResponse>;
  listings?: Maybe<ListingEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  metaTag?: Maybe<MetaTagEntityResponse>;
  metaTags?: Maybe<MetaTagEntityResponseCollection>;
  navigation?: Maybe<NavigationEntityResponse>;
  newsletterBanner?: Maybe<NewsletterBannerEntityResponse>;
  page?: Maybe<PageEntityResponse>;
  pages?: Maybe<PageEntityResponseCollection>;
  product?: Maybe<ProductEntityResponse>;
  redirect?: Maybe<RedirectEntityResponse>;
  redirects?: Maybe<RedirectEntityResponseCollection>;
  startPage?: Maybe<StartPageEntityResponse>;
  testPage?: Maybe<TestPageEntityResponse>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  welcomeConfigurator?: Maybe<WelcomeConfiguratorEntityResponse>;
};


export type QueryAboutPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryBlogPostArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryBlogPostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCartArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryContactPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryEngravingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryEngravingsArgs = {
  filters?: InputMaybe<EngravingFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFooterArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryHomePageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInformationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryInformationsArgs = {
  filters?: InputMaybe<InformationFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInspirationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryInspirationsArgs = {
  filters?: InputMaybe<InspirationFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInspirationsHubArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryIntentionArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryListingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryListingsArgs = {
  filters?: InputMaybe<ListingFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMetaTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMetaTagsArgs = {
  filters?: InputMaybe<MetaTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNavigationArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryNewsletterBannerArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPagesArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryProductArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryRedirectArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRedirectsArgs = {
  filters?: InputMaybe<RedirectFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryStartPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTestPageArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryWelcomeConfiguratorArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};

export type Redirect = {
  __typename?: 'Redirect';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  redirect: ComponentPartsRedirect;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RedirectEntity = {
  __typename?: 'RedirectEntity';
  attributes?: Maybe<Redirect>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type RedirectEntityResponse = {
  __typename?: 'RedirectEntityResponse';
  data?: Maybe<RedirectEntity>;
};

export type RedirectEntityResponseCollection = {
  __typename?: 'RedirectEntityResponseCollection';
  data: Array<RedirectEntity>;
  meta: ResponseCollectionMeta;
};

export type RedirectFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<RedirectFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<RedirectFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<RedirectFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  redirect?: InputMaybe<ComponentPartsRedirectFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RedirectInput = {
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  redirect?: InputMaybe<ComponentPartsRedirectInput>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type StartPage = {
  __typename?: 'StartPage';
  background_image: ComponentPartsBackground;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StartPageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  redirects: Array<Maybe<ComponentStartPageRedirect>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type StartPageLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type StartPageRedirectsArgs = {
  filters?: InputMaybe<ComponentStartPageRedirectFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StartPageEntity = {
  __typename?: 'StartPageEntity';
  attributes?: Maybe<StartPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StartPageEntityResponse = {
  __typename?: 'StartPageEntityResponse';
  data?: Maybe<StartPageEntity>;
};

export type StartPageInput = {
  background_image?: InputMaybe<ComponentPartsBackgroundInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  redirects?: InputMaybe<Array<InputMaybe<ComponentStartPageRedirectInput>>>;
};

export type StartPageRelationResponseCollection = {
  __typename?: 'StartPageRelationResponseCollection';
  data: Array<StartPageEntity>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type TestPage = {
  __typename?: 'TestPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TestPageEntity = {
  __typename?: 'TestPageEntity';
  attributes?: Maybe<TestPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TestPageEntityResponse = {
  __typename?: 'TestPageEntityResponse';
  data?: Maybe<TestPageEntity>;
};

export type TestPageInput = {
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type WelcomeConfigurator = {
  __typename?: 'WelcomeConfigurator';
  Button1?: Maybe<ComponentPartsCta>;
  Button2?: Maybe<ComponentPartsCta>;
  Description?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<WelcomeConfiguratorRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WelcomeConfiguratorEntity = {
  __typename?: 'WelcomeConfiguratorEntity';
  attributes?: Maybe<WelcomeConfigurator>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type WelcomeConfiguratorEntityResponse = {
  __typename?: 'WelcomeConfiguratorEntityResponse';
  data?: Maybe<WelcomeConfiguratorEntity>;
};

export type WelcomeConfiguratorInput = {
  Button1?: InputMaybe<ComponentPartsCtaInput>;
  Button2?: InputMaybe<ComponentPartsCtaInput>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Heading?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
};

export type WelcomeConfiguratorRelationResponseCollection = {
  __typename?: 'WelcomeConfiguratorRelationResponseCollection';
  data: Array<WelcomeConfiguratorEntity>;
};

export enum Http_Status {
  Found_302 = 'Found_302',
  MovedPermanently_301 = 'Moved_Permanently_301',
  PermanentRedirect_308 = 'Permanent_Redirect_308',
  TemporaryRedirect_307 = 'Temporary_Redirect_307'
}

export type GetAboutPageQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetAboutPageQuery = { __typename?: 'Query', aboutPage?: { __typename?: 'AboutPageEntityResponse', data?: { __typename?: 'AboutPageEntity', attributes?: { __typename?: 'AboutPage', seo?: { __typename?: 'ComponentPartsSeo', id: string, title?: string | undefined, description?: string | undefined, type?: string | undefined, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | undefined } | undefined } | undefined } | undefined, header?: { __typename?: 'ComponentPartsHeader', title?: string | undefined, subtitle?: string | undefined, color?: string | undefined, bg?: string | undefined, cover_navbar?: boolean | undefined, img?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined, sections?: Array<{ __typename?: 'ComponentSectionsBanner', id: string, title?: string | undefined, description?: string | undefined, color?: string | undefined, bg?: string | undefined, alignment?: Enum_Componentsectionsbanner_Alignment | undefined, variant?: string | undefined, section_title?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, link?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | { __typename?: 'ComponentSectionsContentSection', id: string, title?: string | undefined, description?: string | undefined, img_position?: Enum_Componentsectionscontentsection_Img_Position | undefined, bg_color?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | { __typename?: 'ComponentSpecialCustomComponent', component_name?: string | undefined } | { __typename?: 'ComponentSpecialStoryCarousel', id: string, title?: string | undefined, items?: Array<{ __typename?: 'ComponentPartsStoryItem', description?: string | undefined, year?: number | undefined, img?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined> | undefined } | { __typename?: 'Error' } | undefined> | undefined } | undefined } | undefined } | undefined };

export type GetAllBlogPostKeysQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<BlogPostFiltersInput>;
}>;


export type GetAllBlogPostKeysQuery = { __typename?: 'Query', blogPosts?: { __typename?: 'BlogPostEntityResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', url_key?: string | undefined } | undefined }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } } | undefined };

export type GetInspirationsQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInspirationsQuery = { __typename?: 'Query', inspirations?: { __typename?: 'InspirationEntityResponseCollection', data: Array<{ __typename?: 'InspirationEntity', attributes?: { __typename?: 'Inspiration', page?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', url_key: string } | undefined } | undefined } | undefined } | undefined }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } } | undefined };

export type GetBlogPostQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type GetBlogPostQuery = { __typename?: 'Query', blogPost?: { __typename?: 'BlogPostEntityResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title?: string | undefined, category?: Enum_Blogpost_Category | undefined, url_key?: string | undefined, cover_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined, sections?: Array<{ __typename?: 'ComponentSectionsProductsList', id: string, section_title?: string | undefined, rows?: number | undefined, items?: Array<{ __typename?: 'ComponentPartsProduct', id: string, url_key?: string | undefined } | undefined> | undefined } | { __typename?: 'ComponentSectionsRichtext', text?: string | undefined } | { __typename?: 'Error' } | undefined> | undefined } | undefined }> } | undefined };

export type GetBlogPostsQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
  page: Scalars['Int']['input'];
  filters?: InputMaybe<BlogPostFiltersInput>;
}>;


export type GetBlogPostsQuery = { __typename?: 'Query', blogPosts?: { __typename?: 'BlogPostEntityResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title?: string | undefined, date?: any | undefined, category?: Enum_Blogpost_Category | undefined, url_key?: string | undefined, description?: string | undefined, createdAt?: any | undefined, cover_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } } | undefined, newsletterBanner?: { __typename?: 'NewsletterBannerEntityResponse', data?: { __typename?: 'NewsletterBannerEntity', attributes?: { __typename?: 'NewsletterBanner', title?: string | undefined, description?: string | undefined, header?: string | undefined, content?: string | undefined, terms_and_conditions?: string | undefined, submit_btn?: string | undefined, header_2?: string | undefined, content_2?: string | undefined, close_btn?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_2: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined } | undefined } | undefined };

export type GetBlogRelatedPostsQueryVariables = Exact<{
  category: Scalars['String']['input'];
}>;


export type GetBlogRelatedPostsQuery = { __typename?: 'Query', relatedPosts?: { __typename?: 'BlogPostEntityResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', id?: string | undefined, attributes?: { __typename?: 'BlogPost', title?: string | undefined, category?: Enum_Blogpost_Category | undefined, url_key?: string | undefined, cover_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined }> } | undefined };

export type GetCartBannerQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetCartBannerQuery = { __typename?: 'Query', cart?: { __typename?: 'CartEntityResponse', data?: { __typename?: 'CartEntity', attributes?: { __typename?: 'Cart', cartbanner?: { __typename?: 'ComponentCartCartBanner', Items?: Array<{ __typename?: 'ComponentCartItem', order: number, text: string, url?: string | undefined, date_from: any, date_to: any } | undefined> | undefined } | undefined } | undefined } | undefined } | undefined };

export type GetContactPageQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetContactPageQuery = { __typename?: 'Query', contactPage?: { __typename?: 'ContactPageEntityResponse', data?: { __typename?: 'ContactPageEntity', attributes?: { __typename?: 'ContactPage', description?: string | undefined } | undefined } | undefined } | undefined };

export type GetEngravingsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetEngravingsQuery = { __typename?: 'Query', engravings?: { __typename?: 'EngravingEntityResponseCollection', data: Array<{ __typename?: 'EngravingEntity', id?: string | undefined, attributes?: { __typename?: 'Engraving', CategoryName: string, Engravings: Array<{ __typename?: 'ComponentEngravingEngraving', id: string, StartingDate?: any | undefined, Description?: string | undefined, Image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, ImageToSend: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } } | undefined> } | undefined }> } | undefined };

export type GetHomePageQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetHomePageQuery = { __typename?: 'Query', homePage?: { __typename?: 'HomePageEntityResponse', data?: { __typename: 'HomePageEntity', id?: string | undefined, attributes?: { __typename?: 'HomePage', hero?: Array<{ __typename?: 'ComponentSectionsBanner', id: string, title?: string | undefined, description?: string | undefined, color?: string | undefined, bg?: string | undefined, alignment?: Enum_Componentsectionsbanner_Alignment | undefined, variant?: string | undefined, section_title?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, link?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined> | undefined, sections?: Array<{ __typename: 'ComponentSectionsBanner', id: string, title?: string | undefined, description?: string | undefined, color?: string | undefined, bg?: string | undefined, alignment?: Enum_Componentsectionsbanner_Alignment | undefined, variant?: string | undefined, section_title?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, link?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | { __typename: 'ComponentSectionsGrid', id: string, section_title?: string | undefined, items?: Array<{ __typename?: 'ComponentPartsGridItem', id: string, title?: string | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } } | undefined> | undefined } | { __typename: 'ComponentSectionsInstashop', id: string, head_script?: string | undefined, body_script?: string | undefined } | { __typename: 'ComponentSectionsProductsList', id: string, section_title?: string | undefined, rows?: number | undefined, items?: Array<{ __typename?: 'ComponentPartsProduct', id: string, url_key?: string | undefined } | undefined> | undefined } | { __typename: 'ComponentSectionsSlider', id: string, items?: Array<{ __typename?: 'ComponentSectionsBanner', id: string, title?: string | undefined, description?: string | undefined, color?: string | undefined, bg?: string | undefined, alignment?: Enum_Componentsectionsbanner_Alignment | undefined, variant?: string | undefined, section_title?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, link?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined> | undefined } | { __typename: 'ComponentSectionsVideo', id: string, section_title?: string | undefined, text?: string | undefined, url?: string | undefined } | { __typename: 'Error' } | undefined> | undefined, opinions?: { __typename?: 'ComponentSpecialOpinionsSlider', id: string, items?: Array<{ __typename?: 'ComponentPartsOpinion', id: string, text?: string | undefined, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | undefined } | undefined } | undefined } | undefined> | undefined } | undefined, video_mobile?: { __typename?: 'ComponentSectionsVideo', id: string, section_title?: string | undefined, text?: string | undefined, url?: string | undefined } | undefined } | undefined } | undefined } | undefined, newsletterBanner?: { __typename?: 'NewsletterBannerEntityResponse', data?: { __typename?: 'NewsletterBannerEntity', attributes?: { __typename?: 'NewsletterBanner', title?: string | undefined, description?: string | undefined, header?: string | undefined, content?: string | undefined, terms_and_conditions?: string | undefined, submit_btn?: string | undefined, header_2?: string | undefined, content_2?: string | undefined, close_btn?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_2: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined } | undefined } | undefined };

export type GetInformationPageQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetInformationPageQuery = { __typename?: 'Query', informationList?: { __typename?: 'InformationEntityResponseCollection', data: Array<{ __typename?: 'InformationEntity', attributes?: { __typename?: 'Information', title?: string | undefined, order?: number | undefined, page?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', url: string, url_key: string, type?: string | undefined } | undefined } | undefined } | undefined } | undefined }> } | undefined, information?: { __typename?: 'InformationEntityResponseCollection', data: Array<{ __typename?: 'InformationEntity', attributes?: { __typename?: 'Information', title?: string | undefined, seo?: { __typename?: 'ComponentPartsSeo', id: string, title?: string | undefined, description?: string | undefined, type?: string | undefined, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | undefined } | undefined } | undefined } | undefined, sections?: Array<{ __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | { __typename?: 'ComponentSectionsRichtext', text?: string | undefined } | { __typename?: 'ComponentSpecialFaq', items?: Array<{ __typename?: 'ComponentPartsQuestionFaq', id: string, question?: string | undefined, answer?: string | undefined, group?: Enum_Componentpartsquestionfaq_Group | undefined } | undefined> | undefined } | { __typename?: 'ComponentSpecialShipmentTable', title?: string | undefined, items?: Array<{ __typename?: 'ComponentPartsShipmentPrice', id: string, description?: string | undefined, value?: string | undefined } | undefined> | undefined } | { __typename?: 'Error' } | undefined> | undefined } | undefined }> } | undefined };

export type GetInspirationPageQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetInspirationPageQuery = { __typename?: 'Query', inspirations?: { __typename?: 'InspirationEntityResponseCollection', data: Array<{ __typename?: 'InspirationEntity', attributes?: { __typename?: 'Inspiration', page?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', url: string, url_key: string, type?: string | undefined } | undefined } | undefined } | undefined, seo: { __typename?: 'ComponentPartsSeo', id: string, title?: string | undefined, description?: string | undefined, type?: string | undefined, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | undefined } | undefined } | undefined }, header: { __typename?: 'ComponentPartsHeader', title?: string | undefined, subtitle?: string | undefined, color?: string | undefined, bg?: string | undefined, cover_navbar?: boolean | undefined, img?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined }, sections?: Array<{ __typename?: 'ComponentSectionsBanner', id: string, title?: string | undefined, description?: string | undefined, color?: string | undefined, bg?: string | undefined, alignment?: Enum_Componentsectionsbanner_Alignment | undefined, variant?: string | undefined, section_title?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, link?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | { __typename?: 'ComponentSectionsContentSection', id: string, title?: string | undefined, description?: string | undefined, img_position?: Enum_Componentsectionscontentsection_Img_Position | undefined, bg_color?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | { __typename?: 'ComponentSectionsProductsList', id: string, section_title?: string | undefined, rows?: number | undefined, items?: Array<{ __typename?: 'ComponentPartsProduct', id: string, url_key?: string | undefined } | undefined> | undefined } | { __typename?: 'ComponentSectionsRichtext', text?: string | undefined } | { __typename?: 'ComponentSectionsStorySection', id: string, title?: string | undefined, description?: string | undefined, author?: string | undefined, story_img_position?: Enum_Componentsectionsstorysection_Story_Img_Position | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | { __typename?: 'ComponentSpecialCustomComponent', component_name?: string | undefined } | { __typename?: 'ComponentSpecialTalismansSection', id: string, kamienie_swatch?: Array<{ __typename?: 'ComponentPartsDictionary', id: string, key?: string | undefined, value?: string | undefined } | undefined> | undefined, content_section_stone?: { __typename?: 'ComponentSectionsContentSection', id: string, title?: string | undefined, description?: string | undefined, img_position?: Enum_Componentsectionscontentsection_Img_Position | undefined, bg_color?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined, content_section_zodiac?: { __typename?: 'ComponentSectionsContentSection', id: string, title?: string | undefined, description?: string | undefined, img_position?: Enum_Componentsectionscontentsection_Img_Position | undefined, bg_color?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined, products_list_stone?: { __typename?: 'ComponentSectionsProductsList', id: string, section_title?: string | undefined, rows?: number | undefined, items?: Array<{ __typename?: 'ComponentPartsProduct', id: string, url_key?: string | undefined } | undefined> | undefined } | undefined, products_list_zodiac?: { __typename?: 'ComponentSectionsProductsList', id: string, section_title?: string | undefined, rows?: number | undefined, items?: Array<{ __typename?: 'ComponentPartsProduct', id: string, url_key?: string | undefined } | undefined> | undefined } | undefined } | { __typename?: 'Error' } | undefined> | undefined } | undefined }> } | undefined };

export type GetInspirationsHubQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetInspirationsHubQuery = { __typename?: 'Query', inspirationsHub?: { __typename?: 'InspirationsHubEntityResponse', data?: { __typename?: 'InspirationsHubEntity', attributes?: { __typename?: 'InspirationsHub', seo?: { __typename?: 'ComponentPartsSeo', id: string, title?: string | undefined, description?: string | undefined, type?: string | undefined, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | undefined } | undefined } | undefined } | undefined, header?: { __typename?: 'ComponentPartsHeader', title?: string | undefined, subtitle?: string | undefined, color?: string | undefined, bg?: string | undefined, cover_navbar?: boolean | undefined, img?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined, items?: { __typename?: 'ComponentSectionsGrid', id: string, section_title?: string | undefined, items?: Array<{ __typename?: 'ComponentPartsGridItem', id: string, title?: string | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } } | undefined> | undefined } | undefined } | undefined } | undefined } | undefined };

export type GetIntentionsSectionQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetIntentionsSectionQuery = { __typename?: 'Query', intention?: { __typename?: 'IntentionEntityResponse', data?: { __typename?: 'IntentionEntity', attributes?: { __typename?: 'Intention', items_joy?: { __typename?: 'ComponentSectionsProductsList', items?: Array<{ __typename?: 'ComponentPartsProduct', url_key?: string | undefined } | undefined> | undefined } | undefined, items_love?: { __typename?: 'ComponentSectionsProductsList', items?: Array<{ __typename?: 'ComponentPartsProduct', url_key?: string | undefined } | undefined> | undefined } | undefined, items_abundance?: { __typename?: 'ComponentSectionsProductsList', items?: Array<{ __typename?: 'ComponentPartsProduct', url_key?: string | undefined } | undefined> | undefined } | undefined, items_health?: { __typename?: 'ComponentSectionsProductsList', items?: Array<{ __typename?: 'ComponentPartsProduct', url_key?: string | undefined } | undefined> | undefined } | undefined, items_protection?: { __typename?: 'ComponentSectionsProductsList', items?: Array<{ __typename?: 'ComponentPartsProduct', url_key?: string | undefined } | undefined> | undefined } | undefined } | undefined } | undefined } | undefined };

export type GetLayoutQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetLayoutQuery = { __typename?: 'Query', navigation?: { __typename?: 'NavigationEntityResponse', data?: { __typename?: 'NavigationEntity', attributes?: { __typename?: 'Navigation', banner?: { __typename?: 'ComponentNavigationBanner', items?: Array<{ __typename?: 'ComponentNavigationBannerItems', order: number, text: string, url: string, date_from: any, date_to: any } | undefined> | undefined } | undefined, top_menu?: Array<{ __typename?: 'ComponentNavigationTopMenu', id: string, title?: string | undefined, image?: { __typename?: 'ComponentNavigationTopMenuImage', img?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined } | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined, columns?: Array<{ __typename?: 'ComponentNavigationColumn', id: string, title?: string | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined, items?: Array<{ __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined> | undefined } | undefined> | undefined } | undefined> | undefined } | undefined } | undefined } | undefined, footer?: { __typename?: 'FooterEntityResponse', data?: { __typename?: 'FooterEntity', attributes?: { __typename?: 'Footer', company?: string | undefined, contact?: string | undefined, columns?: Array<{ __typename?: 'ComponentNavigationColumn', id: string, title?: string | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined, items?: Array<{ __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined> | undefined } | undefined> | undefined, social_media?: Array<{ __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined> | undefined } | undefined } | undefined } | undefined };

export type GetListingPageQueryVariables = Exact<{
  url: Scalars['String']['input'];
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetListingPageQuery = { __typename?: 'Query', listings?: { __typename?: 'ListingEntityResponseCollection', data: Array<{ __typename?: 'ListingEntity', attributes?: { __typename?: 'Listing', title?: string | undefined, magento_url_path?: string | undefined, description_title?: string | undefined, description?: string | undefined, cover_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined, cover_image_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined, sections?: Array<{ __typename?: 'ComponentSectionsBanner', id: string, title?: string | undefined, description?: string | undefined, color?: string | undefined, bg?: string | undefined, alignment?: Enum_Componentsectionsbanner_Alignment | undefined, variant?: string | undefined, section_title?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, link?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | { __typename?: 'ComponentSectionsContentSection', id: string, title?: string | undefined, description?: string | undefined, img_position?: Enum_Componentsectionscontentsection_Img_Position | undefined, bg_color?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | { __typename?: 'Error' } | undefined> | undefined } | undefined }> } | undefined };

export type GetNewsletterDataQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetNewsletterDataQuery = { __typename?: 'Query', newsletterBanner?: { __typename?: 'NewsletterBannerEntityResponse', data?: { __typename?: 'NewsletterBannerEntity', attributes?: { __typename?: 'NewsletterBanner', title?: string | undefined, description?: string | undefined, header?: string | undefined, content?: string | undefined, terms_and_conditions?: string | undefined, submit_btn?: string | undefined, header_2?: string | undefined, content_2?: string | undefined, close_btn?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_2: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined } | undefined } | undefined };

export type MetaTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type MetaTagsQuery = { __typename?: 'Query', metaTags?: { __typename?: 'MetaTagEntityResponseCollection', data: Array<{ __typename?: 'MetaTagEntity', id?: string | undefined, attributes?: { __typename?: 'MetaTag', url_key: string, noIndex?: boolean | undefined, noFollow?: boolean | undefined } | undefined }> } | undefined };

export type GetProductQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', product?: { __typename?: 'ProductEntityResponse', data?: { __typename?: 'ProductEntity', attributes?: { __typename?: 'Product', pdp_video_desktop?: { __typename?: 'ComponentSectionsVideo', id: string, section_title?: string | undefined, text?: string | undefined, url?: string | undefined } | undefined, pdp_video_mobile?: { __typename?: 'ComponentSectionsVideo', id: string, section_title?: string | undefined, text?: string | undefined, url?: string | undefined } | undefined } | undefined } | undefined } | undefined };

export type StartPageQueryVariables = Exact<{ [key: string]: never; }>;


export type StartPageQuery = { __typename?: 'Query', startPage?: { __typename?: 'StartPageEntityResponse', data?: { __typename?: 'StartPageEntity', id?: string | undefined, attributes?: { __typename?: 'StartPage', redirects: Array<{ __typename?: 'ComponentStartPageRedirect', id: string, title: string, url: string, enabled?: boolean | undefined } | undefined>, background_image: { __typename?: 'ComponentPartsBackground', id: string, desktop: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, width?: number | undefined, height?: number | undefined, url: string } | undefined } | undefined }, mobile: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, width?: number | undefined, height?: number | undefined, url: string } | undefined } | undefined } } } | undefined } | undefined } | undefined };

export type GetWelcomeConfiguratorPageQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetWelcomeConfiguratorPageQuery = { __typename?: 'Query', welcomeConfigurator?: { __typename?: 'WelcomeConfiguratorEntityResponse', data?: { __typename?: 'WelcomeConfiguratorEntity', attributes?: { __typename?: 'WelcomeConfigurator', Heading?: string | undefined, Description?: string | undefined, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined, Button1?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, Button2?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined } | undefined } | undefined } | undefined };

export type PageDataFragment = { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', url: string, url_key: string, type?: string | undefined } | undefined } | undefined };

export type LinkDataFragment = { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined };

export type CtaDataFragment = { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined };

export type ImgDataFragment = { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined };

export type SeoDataFragment = { __typename?: 'ComponentPartsSeo', id: string, title?: string | undefined, description?: string | undefined, type?: string | undefined, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | undefined } | undefined } | undefined };

export type HeaderDataFragment = { __typename?: 'ComponentPartsHeader', title?: string | undefined, subtitle?: string | undefined, color?: string | undefined, bg?: string | undefined, cover_navbar?: boolean | undefined, img?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined };

export type ContentSectionDataFragment = { __typename?: 'ComponentSectionsContentSection', id: string, title?: string | undefined, description?: string | undefined, img_position?: Enum_Componentsectionscontentsection_Img_Position | undefined, bg_color?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined };

export type StorySectionDataFragment = { __typename?: 'ComponentSectionsStorySection', id: string, title?: string | undefined, description?: string | undefined, author?: string | undefined, story_img_position?: Enum_Componentsectionsstorysection_Story_Img_Position | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined };

export type StoryCarouselDataFragment = { __typename?: 'ComponentSpecialStoryCarousel', id: string, title?: string | undefined, items?: Array<{ __typename?: 'ComponentPartsStoryItem', description?: string | undefined, year?: number | undefined, img?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined> | undefined };

export type ProductsListDataFragment = { __typename?: 'ComponentSectionsProductsList', id: string, section_title?: string | undefined, rows?: number | undefined, items?: Array<{ __typename?: 'ComponentPartsProduct', id: string, url_key?: string | undefined } | undefined> | undefined };

export type ImageBannerDataFragment = { __typename?: 'ComponentSectionsBanner', id: string, title?: string | undefined, description?: string | undefined, color?: string | undefined, bg?: string | undefined, alignment?: Enum_Componentsectionsbanner_Alignment | undefined, variant?: string | undefined, section_title?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, link?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined };

export type SliderBannerDataFragment = { __typename?: 'ComponentSectionsSlider', id: string, items?: Array<{ __typename?: 'ComponentSectionsBanner', id: string, title?: string | undefined, description?: string | undefined, color?: string | undefined, bg?: string | undefined, alignment?: Enum_Componentsectionsbanner_Alignment | undefined, variant?: string | undefined, section_title?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, link?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined> | undefined };

export type InstaShopDataFragment = { __typename?: 'ComponentSectionsInstashop', id: string, head_script?: string | undefined, body_script?: string | undefined };

export type VideoDataFragment = { __typename?: 'ComponentSectionsVideo', id: string, section_title?: string | undefined, text?: string | undefined, url?: string | undefined };

export type CustomComponentDataFragment = { __typename?: 'ComponentSpecialCustomComponent', component_name?: string | undefined };

export type GridDataFragment = { __typename?: 'ComponentSectionsGrid', id: string, section_title?: string | undefined, items?: Array<{ __typename?: 'ComponentPartsGridItem', id: string, title?: string | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } } | undefined> | undefined };

export type OpinionsSliderDataFragment = { __typename?: 'ComponentSpecialOpinionsSlider', id: string, items?: Array<{ __typename?: 'ComponentPartsOpinion', id: string, text?: string | undefined, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | undefined } | undefined } | undefined } | undefined> | undefined };

export type NewsletterDataFragment = { __typename?: 'NewsletterBanner', title?: string | undefined, description?: string | undefined, header?: string | undefined, content?: string | undefined, terms_and_conditions?: string | undefined, submit_btn?: string | undefined, header_2?: string | undefined, content_2?: string | undefined, close_btn?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_2: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined };

export type RichTextDataFragment = { __typename?: 'ComponentSectionsRichtext', text?: string | undefined };

export type FaqDataFragment = { __typename?: 'ComponentSpecialFaq', items?: Array<{ __typename?: 'ComponentPartsQuestionFaq', id: string, question?: string | undefined, answer?: string | undefined, group?: Enum_Componentpartsquestionfaq_Group | undefined } | undefined> | undefined };

export type ShipmentTableDataFragment = { __typename?: 'ComponentSpecialShipmentTable', title?: string | undefined, items?: Array<{ __typename?: 'ComponentPartsShipmentPrice', id: string, description?: string | undefined, value?: string | undefined } | undefined> | undefined };

export type TalismansSectionDataFragment = { __typename?: 'ComponentSpecialTalismansSection', id: string, kamienie_swatch?: Array<{ __typename?: 'ComponentPartsDictionary', id: string, key?: string | undefined, value?: string | undefined } | undefined> | undefined, content_section_stone?: { __typename?: 'ComponentSectionsContentSection', id: string, title?: string | undefined, description?: string | undefined, img_position?: Enum_Componentsectionscontentsection_Img_Position | undefined, bg_color?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined, content_section_zodiac?: { __typename?: 'ComponentSectionsContentSection', id: string, title?: string | undefined, description?: string | undefined, img_position?: Enum_Componentsectionscontentsection_Img_Position | undefined, bg_color?: string | undefined, cta?: { __typename?: 'ComponentPartsCta', id: string, text?: string | undefined, variant?: Enum_Componentpartscta_Variant | undefined, reversed?: boolean | undefined, link?: { __typename?: 'ComponentPartsLink', id: string, external_href?: string | undefined, target?: Enum_Componentpartslink_Target | undefined, text?: string | undefined, href?: string | undefined, rel?: Enum_Componentpartslink_Rel | undefined } | undefined } | undefined, img: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined }, img_mobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | undefined, attributes?: { __typename?: 'UploadFile', alternativeText?: string | undefined, url: string, width?: number | undefined, height?: number | undefined } | undefined } | undefined } | undefined } | undefined, products_list_stone?: { __typename?: 'ComponentSectionsProductsList', id: string, section_title?: string | undefined, rows?: number | undefined, items?: Array<{ __typename?: 'ComponentPartsProduct', id: string, url_key?: string | undefined } | undefined> | undefined } | undefined, products_list_zodiac?: { __typename?: 'ComponentSectionsProductsList', id: string, section_title?: string | undefined, rows?: number | undefined, items?: Array<{ __typename?: 'ComponentPartsProduct', id: string, url_key?: string | undefined } | undefined> | undefined } | undefined };

export const PageDataFragmentDoc = gql`
    fragment PageData on PageEntityResponse {
  data {
    attributes {
      url
      url_key
      type
    }
  }
}
    `;
export const SeoDataFragmentDoc = gql`
    fragment SeoData on ComponentPartsSeo {
  id
  title
  description
  type
  image {
    data {
      attributes {
        url
      }
    }
  }
}
    `;
export const ImgDataFragmentDoc = gql`
    fragment ImgData on UploadFileEntityResponse {
  data {
    id
    attributes {
      alternativeText
      url
      width
      height
    }
  }
}
    `;
export const HeaderDataFragmentDoc = gql`
    fragment HeaderData on ComponentPartsHeader {
  title
  subtitle
  color
  bg
  img {
    ...ImgData
  }
  img_mobile {
    ...ImgData
  }
  cover_navbar
}
    ${ImgDataFragmentDoc}`;
export const LinkDataFragmentDoc = gql`
    fragment LinkData on ComponentPartsLink {
  id
  external_href
  target
  text
  href
  rel
}
    `;
export const CtaDataFragmentDoc = gql`
    fragment CtaData on ComponentPartsCta {
  id
  text
  link {
    ...LinkData
  }
  variant
  reversed
}
    ${LinkDataFragmentDoc}`;
export const ContentSectionDataFragmentDoc = gql`
    fragment ContentSectionData on ComponentSectionsContentSection {
  id
  title
  description
  cta {
    ...CtaData
  }
  img {
    ...ImgData
  }
  img_mobile {
    ...ImgData
  }
  img_position
  bg_color
}
    ${CtaDataFragmentDoc}
${ImgDataFragmentDoc}`;
export const StorySectionDataFragmentDoc = gql`
    fragment StorySectionData on ComponentSectionsStorySection {
  id
  title
  description
  author
  img {
    ...ImgData
  }
  img_mobile {
    ...ImgData
  }
  story_img_position
}
    ${ImgDataFragmentDoc}`;
export const StoryCarouselDataFragmentDoc = gql`
    fragment StoryCarouselData on ComponentSpecialStoryCarousel {
  id
  title
  items {
    description
    year
    img {
      ...ImgData
    }
  }
}
    ${ImgDataFragmentDoc}`;
export const ProductsListDataFragmentDoc = gql`
    fragment ProductsListData on ComponentSectionsProductsList {
  id
  section_title
  items {
    id
    url_key
  }
  rows
}
    `;
export const ImageBannerDataFragmentDoc = gql`
    fragment ImageBannerData on ComponentSectionsBanner {
  id
  title
  description
  color
  bg
  alignment
  cta {
    ...CtaData
  }
  link {
    ...CtaData
  }
  img {
    ...ImgData
  }
  img_mobile {
    ...ImgData
  }
  variant
  section_title
}
    ${CtaDataFragmentDoc}
${ImgDataFragmentDoc}`;
export const SliderBannerDataFragmentDoc = gql`
    fragment SliderBannerData on ComponentSectionsSlider {
  id
  items {
    ...ImageBannerData
  }
}
    ${ImageBannerDataFragmentDoc}`;
export const InstaShopDataFragmentDoc = gql`
    fragment InstaShopData on ComponentSectionsInstashop {
  id
  head_script
  body_script
}
    `;
export const VideoDataFragmentDoc = gql`
    fragment VideoData on ComponentSectionsVideo {
  id
  section_title
  text
  url
}
    `;
export const CustomComponentDataFragmentDoc = gql`
    fragment CustomComponentData on ComponentSpecialCustomComponent {
  component_name
}
    `;
export const GridDataFragmentDoc = gql`
    fragment GridData on ComponentSectionsGrid {
  id
  section_title
  items {
    id
    title
    link {
      ...LinkData
    }
    img {
      data {
        id
        attributes {
          alternativeText
          url
          width
          height
        }
      }
    }
  }
}
    ${LinkDataFragmentDoc}`;
export const OpinionsSliderDataFragmentDoc = gql`
    fragment OpinionsSliderData on ComponentSpecialOpinionsSlider {
  id
  items {
    id
    text
    logo {
      data {
        attributes {
          url
        }
      }
    }
  }
}
    `;
export const NewsletterDataFragmentDoc = gql`
    fragment NewsletterData on NewsletterBanner {
  title
  description
  header
  content
  terms_and_conditions
  submit_btn
  header_2
  content_2
  close_btn
  cta {
    ...CtaData
  }
  img {
    ...ImgData
  }
  img_2 {
    ...ImgData
  }
  img_mobile {
    ...ImgData
  }
}
    ${CtaDataFragmentDoc}
${ImgDataFragmentDoc}`;
export const RichTextDataFragmentDoc = gql`
    fragment RichTextData on ComponentSectionsRichtext {
  text
}
    `;
export const FaqDataFragmentDoc = gql`
    fragment FaqData on ComponentSpecialFaq {
  items {
    id
    question
    answer
    group
  }
}
    `;
export const ShipmentTableDataFragmentDoc = gql`
    fragment ShipmentTableData on ComponentSpecialShipmentTable {
  title
  items {
    id
    description
    value
  }
}
    `;
export const TalismansSectionDataFragmentDoc = gql`
    fragment TalismansSectionData on ComponentSpecialTalismansSection {
  id
  kamienie_swatch {
    id
    key
    value
  }
  content_section_stone {
    id
    title
    description
    cta {
      ...CtaData
    }
    img {
      ...ImgData
    }
    img_mobile {
      ...ImgData
    }
    img_position
    bg_color
  }
  content_section_zodiac {
    id
    title
    description
    cta {
      ...CtaData
    }
    img {
      ...ImgData
    }
    img_mobile {
      ...ImgData
    }
    img_position
    bg_color
  }
  products_list_stone {
    id
    section_title
    items {
      id
      url_key
    }
    rows
  }
  products_list_zodiac {
    id
    section_title
    items {
      id
      url_key
    }
    rows
  }
}
    ${CtaDataFragmentDoc}
${ImgDataFragmentDoc}`;
export const GetAboutPageDocument = gql`
    query GetAboutPage($locale: I18NLocaleCode!) {
  aboutPage(locale: $locale) {
    data {
      attributes {
        seo {
          ...SeoData
        }
        header {
          ...HeaderData
        }
        sections {
          ...ImageBannerData
          ...ContentSectionData
          ...CustomComponentData
          ...StoryCarouselData
        }
      }
    }
  }
}
    ${SeoDataFragmentDoc}
${HeaderDataFragmentDoc}
${ImageBannerDataFragmentDoc}
${ContentSectionDataFragmentDoc}
${CustomComponentDataFragmentDoc}
${StoryCarouselDataFragmentDoc}`;

/**
 * __useGetAboutPageQuery__
 *
 * To run a query within a React component, call `useGetAboutPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAboutPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAboutPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetAboutPageQuery(baseOptions: Apollo.QueryHookOptions<GetAboutPageQuery, GetAboutPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAboutPageQuery, GetAboutPageQueryVariables>(GetAboutPageDocument, options);
      }
export function useGetAboutPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAboutPageQuery, GetAboutPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAboutPageQuery, GetAboutPageQueryVariables>(GetAboutPageDocument, options);
        }
export function useGetAboutPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAboutPageQuery, GetAboutPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAboutPageQuery, GetAboutPageQueryVariables>(GetAboutPageDocument, options);
        }
export type GetAboutPageQueryHookResult = ReturnType<typeof useGetAboutPageQuery>;
export type GetAboutPageLazyQueryHookResult = ReturnType<typeof useGetAboutPageLazyQuery>;
export type GetAboutPageSuspenseQueryHookResult = ReturnType<typeof useGetAboutPageSuspenseQuery>;
export type GetAboutPageQueryResult = Apollo.QueryResult<GetAboutPageQuery, GetAboutPageQueryVariables>;
export const GetAllBlogPostKeysDocument = gql`
    query GetAllBlogPostKeys($locale: I18NLocaleCode!, $page: Int = 1, $pageSize: Int = 300, $filters: BlogPostFiltersInput) {
  blogPosts(
    locale: $locale
    filters: $filters
    pagination: {page: $page, pageSize: $pageSize}
    sort: ["date:desc", "createdAt:desc"]
  ) {
    data {
      attributes {
        url_key
      }
    }
    meta {
      pagination {
        total
        page
        pageSize
        pageCount
      }
    }
  }
}
    `;

/**
 * __useGetAllBlogPostKeysQuery__
 *
 * To run a query within a React component, call `useGetAllBlogPostKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBlogPostKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBlogPostKeysQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAllBlogPostKeysQuery(baseOptions: Apollo.QueryHookOptions<GetAllBlogPostKeysQuery, GetAllBlogPostKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBlogPostKeysQuery, GetAllBlogPostKeysQueryVariables>(GetAllBlogPostKeysDocument, options);
      }
export function useGetAllBlogPostKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBlogPostKeysQuery, GetAllBlogPostKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBlogPostKeysQuery, GetAllBlogPostKeysQueryVariables>(GetAllBlogPostKeysDocument, options);
        }
export function useGetAllBlogPostKeysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllBlogPostKeysQuery, GetAllBlogPostKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllBlogPostKeysQuery, GetAllBlogPostKeysQueryVariables>(GetAllBlogPostKeysDocument, options);
        }
export type GetAllBlogPostKeysQueryHookResult = ReturnType<typeof useGetAllBlogPostKeysQuery>;
export type GetAllBlogPostKeysLazyQueryHookResult = ReturnType<typeof useGetAllBlogPostKeysLazyQuery>;
export type GetAllBlogPostKeysSuspenseQueryHookResult = ReturnType<typeof useGetAllBlogPostKeysSuspenseQuery>;
export type GetAllBlogPostKeysQueryResult = Apollo.QueryResult<GetAllBlogPostKeysQuery, GetAllBlogPostKeysQueryVariables>;
export const GetInspirationsDocument = gql`
    query GetInspirations($locale: I18NLocaleCode!, $page: Int = 1, $pageSize: Int = 300) {
  inspirations(locale: $locale, pagination: {page: $page, pageSize: $pageSize}) {
    data {
      attributes {
        page {
          data {
            attributes {
              url_key
            }
          }
        }
      }
    }
    meta {
      pagination {
        total
        page
        pageSize
        pageCount
      }
    }
  }
}
    `;

/**
 * __useGetInspirationsQuery__
 *
 * To run a query within a React component, call `useGetInspirationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspirationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspirationsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetInspirationsQuery(baseOptions: Apollo.QueryHookOptions<GetInspirationsQuery, GetInspirationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInspirationsQuery, GetInspirationsQueryVariables>(GetInspirationsDocument, options);
      }
export function useGetInspirationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInspirationsQuery, GetInspirationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInspirationsQuery, GetInspirationsQueryVariables>(GetInspirationsDocument, options);
        }
export function useGetInspirationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInspirationsQuery, GetInspirationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInspirationsQuery, GetInspirationsQueryVariables>(GetInspirationsDocument, options);
        }
export type GetInspirationsQueryHookResult = ReturnType<typeof useGetInspirationsQuery>;
export type GetInspirationsLazyQueryHookResult = ReturnType<typeof useGetInspirationsLazyQuery>;
export type GetInspirationsSuspenseQueryHookResult = ReturnType<typeof useGetInspirationsSuspenseQuery>;
export type GetInspirationsQueryResult = Apollo.QueryResult<GetInspirationsQuery, GetInspirationsQueryVariables>;
export const GetBlogPostDocument = gql`
    query GetBlogPost($urlKey: String!) {
  blogPost: blogPosts(filters: {url_key: {eq: $urlKey}}) {
    data {
      attributes {
        title
        category
        url_key
        cover_image {
          ...ImgData
        }
        sections {
          ...ProductsListData
          ...RichTextData
        }
      }
    }
  }
}
    ${ImgDataFragmentDoc}
${ProductsListDataFragmentDoc}
${RichTextDataFragmentDoc}`;

/**
 * __useGetBlogPostQuery__
 *
 * To run a query within a React component, call `useGetBlogPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogPostQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useGetBlogPostQuery(baseOptions: Apollo.QueryHookOptions<GetBlogPostQuery, GetBlogPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlogPostQuery, GetBlogPostQueryVariables>(GetBlogPostDocument, options);
      }
export function useGetBlogPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogPostQuery, GetBlogPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlogPostQuery, GetBlogPostQueryVariables>(GetBlogPostDocument, options);
        }
export function useGetBlogPostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBlogPostQuery, GetBlogPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlogPostQuery, GetBlogPostQueryVariables>(GetBlogPostDocument, options);
        }
export type GetBlogPostQueryHookResult = ReturnType<typeof useGetBlogPostQuery>;
export type GetBlogPostLazyQueryHookResult = ReturnType<typeof useGetBlogPostLazyQuery>;
export type GetBlogPostSuspenseQueryHookResult = ReturnType<typeof useGetBlogPostSuspenseQuery>;
export type GetBlogPostQueryResult = Apollo.QueryResult<GetBlogPostQuery, GetBlogPostQueryVariables>;
export const GetBlogPostsDocument = gql`
    query GetBlogPosts($locale: I18NLocaleCode!, $page: Int!, $filters: BlogPostFiltersInput) {
  blogPosts(
    locale: $locale
    filters: $filters
    pagination: {page: $page, pageSize: 5}
    sort: ["date:desc", "createdAt:desc"]
  ) {
    data {
      attributes {
        title
        date
        category
        url_key
        description
        createdAt
        cover_image {
          ...ImgData
        }
      }
    }
    meta {
      pagination {
        total
        page
        pageSize
        pageCount
      }
    }
  }
  newsletterBanner(locale: $locale) {
    data {
      attributes {
        ...NewsletterData
      }
    }
  }
}
    ${ImgDataFragmentDoc}
${NewsletterDataFragmentDoc}`;

/**
 * __useGetBlogPostsQuery__
 *
 * To run a query within a React component, call `useGetBlogPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogPostsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBlogPostsQuery(baseOptions: Apollo.QueryHookOptions<GetBlogPostsQuery, GetBlogPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlogPostsQuery, GetBlogPostsQueryVariables>(GetBlogPostsDocument, options);
      }
export function useGetBlogPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogPostsQuery, GetBlogPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlogPostsQuery, GetBlogPostsQueryVariables>(GetBlogPostsDocument, options);
        }
export function useGetBlogPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBlogPostsQuery, GetBlogPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlogPostsQuery, GetBlogPostsQueryVariables>(GetBlogPostsDocument, options);
        }
export type GetBlogPostsQueryHookResult = ReturnType<typeof useGetBlogPostsQuery>;
export type GetBlogPostsLazyQueryHookResult = ReturnType<typeof useGetBlogPostsLazyQuery>;
export type GetBlogPostsSuspenseQueryHookResult = ReturnType<typeof useGetBlogPostsSuspenseQuery>;
export type GetBlogPostsQueryResult = Apollo.QueryResult<GetBlogPostsQuery, GetBlogPostsQueryVariables>;
export const GetBlogRelatedPostsDocument = gql`
    query GetBlogRelatedPosts($category: String!) {
  relatedPosts: blogPosts(
    filters: {category: {eq: $category}}
    pagination: {pageSize: 4}
  ) {
    data {
      id
      attributes {
        title
        category
        url_key
        cover_image {
          ...ImgData
        }
      }
    }
  }
}
    ${ImgDataFragmentDoc}`;

/**
 * __useGetBlogRelatedPostsQuery__
 *
 * To run a query within a React component, call `useGetBlogRelatedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogRelatedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogRelatedPostsQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetBlogRelatedPostsQuery(baseOptions: Apollo.QueryHookOptions<GetBlogRelatedPostsQuery, GetBlogRelatedPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlogRelatedPostsQuery, GetBlogRelatedPostsQueryVariables>(GetBlogRelatedPostsDocument, options);
      }
export function useGetBlogRelatedPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogRelatedPostsQuery, GetBlogRelatedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlogRelatedPostsQuery, GetBlogRelatedPostsQueryVariables>(GetBlogRelatedPostsDocument, options);
        }
export function useGetBlogRelatedPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBlogRelatedPostsQuery, GetBlogRelatedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlogRelatedPostsQuery, GetBlogRelatedPostsQueryVariables>(GetBlogRelatedPostsDocument, options);
        }
export type GetBlogRelatedPostsQueryHookResult = ReturnType<typeof useGetBlogRelatedPostsQuery>;
export type GetBlogRelatedPostsLazyQueryHookResult = ReturnType<typeof useGetBlogRelatedPostsLazyQuery>;
export type GetBlogRelatedPostsSuspenseQueryHookResult = ReturnType<typeof useGetBlogRelatedPostsSuspenseQuery>;
export type GetBlogRelatedPostsQueryResult = Apollo.QueryResult<GetBlogRelatedPostsQuery, GetBlogRelatedPostsQueryVariables>;
export const GetCartBannerDocument = gql`
    query GetCartBanner($locale: I18NLocaleCode!) {
  cart(locale: $locale) {
    data {
      attributes {
        cartbanner {
          Items {
            order
            text
            url
            date_from
            date_to
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCartBannerQuery__
 *
 * To run a query within a React component, call `useGetCartBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartBannerQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetCartBannerQuery(baseOptions: Apollo.QueryHookOptions<GetCartBannerQuery, GetCartBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartBannerQuery, GetCartBannerQueryVariables>(GetCartBannerDocument, options);
      }
export function useGetCartBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartBannerQuery, GetCartBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartBannerQuery, GetCartBannerQueryVariables>(GetCartBannerDocument, options);
        }
export function useGetCartBannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCartBannerQuery, GetCartBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartBannerQuery, GetCartBannerQueryVariables>(GetCartBannerDocument, options);
        }
export type GetCartBannerQueryHookResult = ReturnType<typeof useGetCartBannerQuery>;
export type GetCartBannerLazyQueryHookResult = ReturnType<typeof useGetCartBannerLazyQuery>;
export type GetCartBannerSuspenseQueryHookResult = ReturnType<typeof useGetCartBannerSuspenseQuery>;
export type GetCartBannerQueryResult = Apollo.QueryResult<GetCartBannerQuery, GetCartBannerQueryVariables>;
export const GetContactPageDocument = gql`
    query GetContactPage($locale: I18NLocaleCode!) {
  contactPage(locale: $locale) {
    data {
      attributes {
        description
      }
    }
  }
}
    `;

/**
 * __useGetContactPageQuery__
 *
 * To run a query within a React component, call `useGetContactPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetContactPageQuery(baseOptions: Apollo.QueryHookOptions<GetContactPageQuery, GetContactPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactPageQuery, GetContactPageQueryVariables>(GetContactPageDocument, options);
      }
export function useGetContactPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactPageQuery, GetContactPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactPageQuery, GetContactPageQueryVariables>(GetContactPageDocument, options);
        }
export function useGetContactPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContactPageQuery, GetContactPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactPageQuery, GetContactPageQueryVariables>(GetContactPageDocument, options);
        }
export type GetContactPageQueryHookResult = ReturnType<typeof useGetContactPageQuery>;
export type GetContactPageLazyQueryHookResult = ReturnType<typeof useGetContactPageLazyQuery>;
export type GetContactPageSuspenseQueryHookResult = ReturnType<typeof useGetContactPageSuspenseQuery>;
export type GetContactPageQueryResult = Apollo.QueryResult<GetContactPageQuery, GetContactPageQueryVariables>;
export const GetEngravingsDocument = gql`
    query GetEngravings($locale: I18NLocaleCode = "pl") {
  engravings(locale: $locale, pagination: {limit: 200}, sort: "order:asc") {
    data {
      id
      attributes {
        CategoryName
        Engravings {
          id
          Image {
            ...ImgData
          }
          ImageToSend {
            ...ImgData
          }
          StartingDate
          Description
        }
      }
    }
  }
}
    ${ImgDataFragmentDoc}`;

/**
 * __useGetEngravingsQuery__
 *
 * To run a query within a React component, call `useGetEngravingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngravingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngravingsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetEngravingsQuery(baseOptions?: Apollo.QueryHookOptions<GetEngravingsQuery, GetEngravingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEngravingsQuery, GetEngravingsQueryVariables>(GetEngravingsDocument, options);
      }
export function useGetEngravingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEngravingsQuery, GetEngravingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEngravingsQuery, GetEngravingsQueryVariables>(GetEngravingsDocument, options);
        }
export function useGetEngravingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEngravingsQuery, GetEngravingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEngravingsQuery, GetEngravingsQueryVariables>(GetEngravingsDocument, options);
        }
export type GetEngravingsQueryHookResult = ReturnType<typeof useGetEngravingsQuery>;
export type GetEngravingsLazyQueryHookResult = ReturnType<typeof useGetEngravingsLazyQuery>;
export type GetEngravingsSuspenseQueryHookResult = ReturnType<typeof useGetEngravingsSuspenseQuery>;
export type GetEngravingsQueryResult = Apollo.QueryResult<GetEngravingsQuery, GetEngravingsQueryVariables>;
export const GetHomePageDocument = gql`
    query GetHomePage($locale: I18NLocaleCode!) {
  homePage(locale: $locale) {
    data {
      id
      __typename
      attributes {
        hero {
          ...ImageBannerData
        }
        sections {
          __typename
          ...ImageBannerData
          ...InstaShopData
          ...VideoData
          ...GridData
          ...ProductsListData
          ...SliderBannerData
        }
        opinions {
          ...OpinionsSliderData
        }
        video_mobile {
          ...VideoData
        }
      }
    }
  }
  newsletterBanner(locale: $locale) {
    data {
      attributes {
        ...NewsletterData
      }
    }
  }
}
    ${ImageBannerDataFragmentDoc}
${InstaShopDataFragmentDoc}
${VideoDataFragmentDoc}
${GridDataFragmentDoc}
${ProductsListDataFragmentDoc}
${SliderBannerDataFragmentDoc}
${OpinionsSliderDataFragmentDoc}
${NewsletterDataFragmentDoc}`;

/**
 * __useGetHomePageQuery__
 *
 * To run a query within a React component, call `useGetHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomePageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetHomePageQuery(baseOptions: Apollo.QueryHookOptions<GetHomePageQuery, GetHomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomePageQuery, GetHomePageQueryVariables>(GetHomePageDocument, options);
      }
export function useGetHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomePageQuery, GetHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomePageQuery, GetHomePageQueryVariables>(GetHomePageDocument, options);
        }
export function useGetHomePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHomePageQuery, GetHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHomePageQuery, GetHomePageQueryVariables>(GetHomePageDocument, options);
        }
export type GetHomePageQueryHookResult = ReturnType<typeof useGetHomePageQuery>;
export type GetHomePageLazyQueryHookResult = ReturnType<typeof useGetHomePageLazyQuery>;
export type GetHomePageSuspenseQueryHookResult = ReturnType<typeof useGetHomePageSuspenseQuery>;
export type GetHomePageQueryResult = Apollo.QueryResult<GetHomePageQuery, GetHomePageQueryVariables>;
export const GetInformationPageDocument = gql`
    query GetInformationPage($urlKey: String!, $locale: I18NLocaleCode) {
  informationList: informations(locale: $locale) {
    data {
      attributes {
        title
        order
        page {
          ...PageData
        }
      }
    }
  }
  information: informations(
    locale: $locale
    filters: {page: {url_key: {eq: $urlKey}}}
  ) {
    data {
      attributes {
        title
        seo {
          ...SeoData
        }
        sections {
          ...RichTextData
          ...FaqData
          ...ShipmentTableData
          ...CtaData
        }
      }
    }
  }
}
    ${PageDataFragmentDoc}
${SeoDataFragmentDoc}
${RichTextDataFragmentDoc}
${FaqDataFragmentDoc}
${ShipmentTableDataFragmentDoc}
${CtaDataFragmentDoc}`;

/**
 * __useGetInformationPageQuery__
 *
 * To run a query within a React component, call `useGetInformationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInformationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInformationPageQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetInformationPageQuery(baseOptions: Apollo.QueryHookOptions<GetInformationPageQuery, GetInformationPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInformationPageQuery, GetInformationPageQueryVariables>(GetInformationPageDocument, options);
      }
export function useGetInformationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInformationPageQuery, GetInformationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInformationPageQuery, GetInformationPageQueryVariables>(GetInformationPageDocument, options);
        }
export function useGetInformationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInformationPageQuery, GetInformationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInformationPageQuery, GetInformationPageQueryVariables>(GetInformationPageDocument, options);
        }
export type GetInformationPageQueryHookResult = ReturnType<typeof useGetInformationPageQuery>;
export type GetInformationPageLazyQueryHookResult = ReturnType<typeof useGetInformationPageLazyQuery>;
export type GetInformationPageSuspenseQueryHookResult = ReturnType<typeof useGetInformationPageSuspenseQuery>;
export type GetInformationPageQueryResult = Apollo.QueryResult<GetInformationPageQuery, GetInformationPageQueryVariables>;
export const GetInspirationPageDocument = gql`
    query GetInspirationPage($urlKey: String!, $locale: I18NLocaleCode!) {
  inspirations(filters: {page: {url_key: {eq: $urlKey}}}, locale: $locale) {
    data {
      attributes {
        page {
          ...PageData
        }
        seo {
          ...SeoData
        }
        header {
          ...HeaderData
        }
        sections {
          ...StorySectionData
          ...ContentSectionData
          ...ProductsListData
          ...ImageBannerData
          ...CustomComponentData
          ...TalismansSectionData
          ...RichTextData
        }
      }
    }
  }
}
    ${PageDataFragmentDoc}
${SeoDataFragmentDoc}
${HeaderDataFragmentDoc}
${StorySectionDataFragmentDoc}
${ContentSectionDataFragmentDoc}
${ProductsListDataFragmentDoc}
${ImageBannerDataFragmentDoc}
${CustomComponentDataFragmentDoc}
${TalismansSectionDataFragmentDoc}
${RichTextDataFragmentDoc}`;

/**
 * __useGetInspirationPageQuery__
 *
 * To run a query within a React component, call `useGetInspirationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspirationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspirationPageQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetInspirationPageQuery(baseOptions: Apollo.QueryHookOptions<GetInspirationPageQuery, GetInspirationPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInspirationPageQuery, GetInspirationPageQueryVariables>(GetInspirationPageDocument, options);
      }
export function useGetInspirationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInspirationPageQuery, GetInspirationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInspirationPageQuery, GetInspirationPageQueryVariables>(GetInspirationPageDocument, options);
        }
export function useGetInspirationPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInspirationPageQuery, GetInspirationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInspirationPageQuery, GetInspirationPageQueryVariables>(GetInspirationPageDocument, options);
        }
export type GetInspirationPageQueryHookResult = ReturnType<typeof useGetInspirationPageQuery>;
export type GetInspirationPageLazyQueryHookResult = ReturnType<typeof useGetInspirationPageLazyQuery>;
export type GetInspirationPageSuspenseQueryHookResult = ReturnType<typeof useGetInspirationPageSuspenseQuery>;
export type GetInspirationPageQueryResult = Apollo.QueryResult<GetInspirationPageQuery, GetInspirationPageQueryVariables>;
export const GetInspirationsHubDocument = gql`
    query GetInspirationsHub($locale: I18NLocaleCode!) {
  inspirationsHub(locale: $locale) {
    data {
      attributes {
        seo {
          ...SeoData
        }
        header {
          ...HeaderData
        }
        items {
          ...GridData
        }
      }
    }
  }
}
    ${SeoDataFragmentDoc}
${HeaderDataFragmentDoc}
${GridDataFragmentDoc}`;

/**
 * __useGetInspirationsHubQuery__
 *
 * To run a query within a React component, call `useGetInspirationsHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspirationsHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspirationsHubQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetInspirationsHubQuery(baseOptions: Apollo.QueryHookOptions<GetInspirationsHubQuery, GetInspirationsHubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInspirationsHubQuery, GetInspirationsHubQueryVariables>(GetInspirationsHubDocument, options);
      }
export function useGetInspirationsHubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInspirationsHubQuery, GetInspirationsHubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInspirationsHubQuery, GetInspirationsHubQueryVariables>(GetInspirationsHubDocument, options);
        }
export function useGetInspirationsHubSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInspirationsHubQuery, GetInspirationsHubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInspirationsHubQuery, GetInspirationsHubQueryVariables>(GetInspirationsHubDocument, options);
        }
export type GetInspirationsHubQueryHookResult = ReturnType<typeof useGetInspirationsHubQuery>;
export type GetInspirationsHubLazyQueryHookResult = ReturnType<typeof useGetInspirationsHubLazyQuery>;
export type GetInspirationsHubSuspenseQueryHookResult = ReturnType<typeof useGetInspirationsHubSuspenseQuery>;
export type GetInspirationsHubQueryResult = Apollo.QueryResult<GetInspirationsHubQuery, GetInspirationsHubQueryVariables>;
export const GetIntentionsSectionDocument = gql`
    query GetIntentionsSection($locale: I18NLocaleCode!) {
  intention(locale: $locale) {
    data {
      attributes {
        items_joy {
          items {
            url_key
          }
        }
        items_love {
          items {
            url_key
          }
        }
        items_abundance {
          items {
            url_key
          }
        }
        items_health {
          items {
            url_key
          }
        }
        items_protection {
          items {
            url_key
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetIntentionsSectionQuery__
 *
 * To run a query within a React component, call `useGetIntentionsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntentionsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntentionsSectionQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetIntentionsSectionQuery(baseOptions: Apollo.QueryHookOptions<GetIntentionsSectionQuery, GetIntentionsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntentionsSectionQuery, GetIntentionsSectionQueryVariables>(GetIntentionsSectionDocument, options);
      }
export function useGetIntentionsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntentionsSectionQuery, GetIntentionsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntentionsSectionQuery, GetIntentionsSectionQueryVariables>(GetIntentionsSectionDocument, options);
        }
export function useGetIntentionsSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntentionsSectionQuery, GetIntentionsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntentionsSectionQuery, GetIntentionsSectionQueryVariables>(GetIntentionsSectionDocument, options);
        }
export type GetIntentionsSectionQueryHookResult = ReturnType<typeof useGetIntentionsSectionQuery>;
export type GetIntentionsSectionLazyQueryHookResult = ReturnType<typeof useGetIntentionsSectionLazyQuery>;
export type GetIntentionsSectionSuspenseQueryHookResult = ReturnType<typeof useGetIntentionsSectionSuspenseQuery>;
export type GetIntentionsSectionQueryResult = Apollo.QueryResult<GetIntentionsSectionQuery, GetIntentionsSectionQueryVariables>;
export const GetLayoutDocument = gql`
    query GetLayout($locale: I18NLocaleCode!) {
  navigation(locale: $locale) {
    data {
      attributes {
        banner {
          items {
            order
            text
            url
            date_from
            date_to
          }
        }
        top_menu {
          id
          title
          image {
            img {
              ...ImgData
            }
            link {
              ...LinkData
            }
            cta {
              ...CtaData
            }
          }
          link {
            ...LinkData
          }
          columns {
            id
            title
            link {
              ...LinkData
            }
            items {
              ...LinkData
            }
          }
        }
      }
    }
  }
  footer(locale: $locale) {
    data {
      attributes {
        columns {
          id
          title
          link {
            ...LinkData
          }
          items {
            ...LinkData
          }
        }
        company
        contact
        social_media {
          ...LinkData
        }
      }
    }
  }
}
    ${ImgDataFragmentDoc}
${LinkDataFragmentDoc}
${CtaDataFragmentDoc}`;

/**
 * __useGetLayoutQuery__
 *
 * To run a query within a React component, call `useGetLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLayoutQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetLayoutQuery(baseOptions: Apollo.QueryHookOptions<GetLayoutQuery, GetLayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLayoutQuery, GetLayoutQueryVariables>(GetLayoutDocument, options);
      }
export function useGetLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLayoutQuery, GetLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLayoutQuery, GetLayoutQueryVariables>(GetLayoutDocument, options);
        }
export function useGetLayoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLayoutQuery, GetLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLayoutQuery, GetLayoutQueryVariables>(GetLayoutDocument, options);
        }
export type GetLayoutQueryHookResult = ReturnType<typeof useGetLayoutQuery>;
export type GetLayoutLazyQueryHookResult = ReturnType<typeof useGetLayoutLazyQuery>;
export type GetLayoutSuspenseQueryHookResult = ReturnType<typeof useGetLayoutSuspenseQuery>;
export type GetLayoutQueryResult = Apollo.QueryResult<GetLayoutQuery, GetLayoutQueryVariables>;
export const GetListingPageDocument = gql`
    query GetListingPage($url: String!, $locale: I18NLocaleCode!) {
  listings(filters: {page: {url: {eq: $url}}}, locale: $locale) {
    data {
      attributes {
        title
        magento_url_path
        cover_image {
          ...ImgData
        }
        cover_image_mobile {
          ...ImgData
        }
        description_title
        description
        sections {
          ...ContentSectionData
          ...ImageBannerData
        }
      }
    }
  }
}
    ${ImgDataFragmentDoc}
${ContentSectionDataFragmentDoc}
${ImageBannerDataFragmentDoc}`;

/**
 * __useGetListingPageQuery__
 *
 * To run a query within a React component, call `useGetListingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingPageQuery({
 *   variables: {
 *      url: // value for 'url'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetListingPageQuery(baseOptions: Apollo.QueryHookOptions<GetListingPageQuery, GetListingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingPageQuery, GetListingPageQueryVariables>(GetListingPageDocument, options);
      }
export function useGetListingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingPageQuery, GetListingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingPageQuery, GetListingPageQueryVariables>(GetListingPageDocument, options);
        }
export function useGetListingPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetListingPageQuery, GetListingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetListingPageQuery, GetListingPageQueryVariables>(GetListingPageDocument, options);
        }
export type GetListingPageQueryHookResult = ReturnType<typeof useGetListingPageQuery>;
export type GetListingPageLazyQueryHookResult = ReturnType<typeof useGetListingPageLazyQuery>;
export type GetListingPageSuspenseQueryHookResult = ReturnType<typeof useGetListingPageSuspenseQuery>;
export type GetListingPageQueryResult = Apollo.QueryResult<GetListingPageQuery, GetListingPageQueryVariables>;
export const GetNewsletterDataDocument = gql`
    query GetNewsletterData($locale: I18NLocaleCode!) {
  newsletterBanner(locale: $locale) {
    data {
      attributes {
        ...NewsletterData
      }
    }
  }
}
    ${NewsletterDataFragmentDoc}`;

/**
 * __useGetNewsletterDataQuery__
 *
 * To run a query within a React component, call `useGetNewsletterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsletterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsletterDataQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetNewsletterDataQuery(baseOptions: Apollo.QueryHookOptions<GetNewsletterDataQuery, GetNewsletterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsletterDataQuery, GetNewsletterDataQueryVariables>(GetNewsletterDataDocument, options);
      }
export function useGetNewsletterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsletterDataQuery, GetNewsletterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsletterDataQuery, GetNewsletterDataQueryVariables>(GetNewsletterDataDocument, options);
        }
export function useGetNewsletterDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNewsletterDataQuery, GetNewsletterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewsletterDataQuery, GetNewsletterDataQueryVariables>(GetNewsletterDataDocument, options);
        }
export type GetNewsletterDataQueryHookResult = ReturnType<typeof useGetNewsletterDataQuery>;
export type GetNewsletterDataLazyQueryHookResult = ReturnType<typeof useGetNewsletterDataLazyQuery>;
export type GetNewsletterDataSuspenseQueryHookResult = ReturnType<typeof useGetNewsletterDataSuspenseQuery>;
export type GetNewsletterDataQueryResult = Apollo.QueryResult<GetNewsletterDataQuery, GetNewsletterDataQueryVariables>;
export const MetaTagsDocument = gql`
    query MetaTags {
  metaTags {
    data {
      id
      attributes {
        url_key
        noIndex
        noFollow
      }
    }
  }
}
    `;

/**
 * __useMetaTagsQuery__
 *
 * To run a query within a React component, call `useMetaTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMetaTagsQuery(baseOptions?: Apollo.QueryHookOptions<MetaTagsQuery, MetaTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaTagsQuery, MetaTagsQueryVariables>(MetaTagsDocument, options);
      }
export function useMetaTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaTagsQuery, MetaTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaTagsQuery, MetaTagsQueryVariables>(MetaTagsDocument, options);
        }
export function useMetaTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MetaTagsQuery, MetaTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaTagsQuery, MetaTagsQueryVariables>(MetaTagsDocument, options);
        }
export type MetaTagsQueryHookResult = ReturnType<typeof useMetaTagsQuery>;
export type MetaTagsLazyQueryHookResult = ReturnType<typeof useMetaTagsLazyQuery>;
export type MetaTagsSuspenseQueryHookResult = ReturnType<typeof useMetaTagsSuspenseQuery>;
export type MetaTagsQueryResult = Apollo.QueryResult<MetaTagsQuery, MetaTagsQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($locale: I18NLocaleCode!) {
  product(locale: $locale) {
    data {
      attributes {
        pdp_video_desktop {
          ...VideoData
        }
        pdp_video_mobile {
          ...VideoData
        }
      }
    }
  }
}
    ${VideoDataFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const StartPageDocument = gql`
    query StartPage {
  startPage {
    data {
      id
      attributes {
        redirects {
          id
          title
          url
          enabled
        }
        background_image {
          id
          desktop {
            data {
              id
              attributes {
                alternativeText
                width
                height
                url
              }
            }
          }
          mobile {
            data {
              id
              attributes {
                alternativeText
                width
                height
                url
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useStartPageQuery__
 *
 * To run a query within a React component, call `useStartPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useStartPageQuery(baseOptions?: Apollo.QueryHookOptions<StartPageQuery, StartPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartPageQuery, StartPageQueryVariables>(StartPageDocument, options);
      }
export function useStartPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartPageQuery, StartPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartPageQuery, StartPageQueryVariables>(StartPageDocument, options);
        }
export function useStartPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StartPageQuery, StartPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StartPageQuery, StartPageQueryVariables>(StartPageDocument, options);
        }
export type StartPageQueryHookResult = ReturnType<typeof useStartPageQuery>;
export type StartPageLazyQueryHookResult = ReturnType<typeof useStartPageLazyQuery>;
export type StartPageSuspenseQueryHookResult = ReturnType<typeof useStartPageSuspenseQuery>;
export type StartPageQueryResult = Apollo.QueryResult<StartPageQuery, StartPageQueryVariables>;
export const GetWelcomeConfiguratorPageDocument = gql`
    query GetWelcomeConfiguratorPage($locale: I18NLocaleCode!) {
  welcomeConfigurator(locale: $locale) {
    data {
      attributes {
        Image {
          ...ImgData
        }
        Heading
        Description
        Button1 {
          ...CtaData
        }
        Button2 {
          ...CtaData
        }
      }
    }
  }
}
    ${ImgDataFragmentDoc}
${CtaDataFragmentDoc}`;

/**
 * __useGetWelcomeConfiguratorPageQuery__
 *
 * To run a query within a React component, call `useGetWelcomeConfiguratorPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWelcomeConfiguratorPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWelcomeConfiguratorPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetWelcomeConfiguratorPageQuery(baseOptions: Apollo.QueryHookOptions<GetWelcomeConfiguratorPageQuery, GetWelcomeConfiguratorPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWelcomeConfiguratorPageQuery, GetWelcomeConfiguratorPageQueryVariables>(GetWelcomeConfiguratorPageDocument, options);
      }
export function useGetWelcomeConfiguratorPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWelcomeConfiguratorPageQuery, GetWelcomeConfiguratorPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWelcomeConfiguratorPageQuery, GetWelcomeConfiguratorPageQueryVariables>(GetWelcomeConfiguratorPageDocument, options);
        }
export function useGetWelcomeConfiguratorPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWelcomeConfiguratorPageQuery, GetWelcomeConfiguratorPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWelcomeConfiguratorPageQuery, GetWelcomeConfiguratorPageQueryVariables>(GetWelcomeConfiguratorPageDocument, options);
        }
export type GetWelcomeConfiguratorPageQueryHookResult = ReturnType<typeof useGetWelcomeConfiguratorPageQuery>;
export type GetWelcomeConfiguratorPageLazyQueryHookResult = ReturnType<typeof useGetWelcomeConfiguratorPageLazyQuery>;
export type GetWelcomeConfiguratorPageSuspenseQueryHookResult = ReturnType<typeof useGetWelcomeConfiguratorPageSuspenseQuery>;
export type GetWelcomeConfiguratorPageQueryResult = Apollo.QueryResult<GetWelcomeConfiguratorPageQuery, GetWelcomeConfiguratorPageQueryVariables>;